/* eslint-disable no-useless-escape */
export const CAPI_BASE_URL = {
  curl: `https://conversations.messagebird.com/v1/`,
};

export const ERROR_OBJECT = {
  json: `{
  "errors": [
  {
    "code": 1001,
    "description": "You are requesting with an invalid credential.",
    "parameter": null
  }
  ]
}`,
};

export const SEND_ENDPOINT = {
  json: `POST /v1/send`,
};

export const SEND_REQUEST_EXAMPLE = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/send" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "to": "+31612345678",
    "from": "619747f69cf940a98fb443140ce9aed2",
    "type": "text",
    "content": {
      "text": "Hello!"
    },
    "reportUrl": "https://example.com/reports",
    "source": {
      "foo": "bar"
    }
  }'`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

var params = {
  'to': '+31612345678',
  'from': '619747f69cf940a98fb443140ce9aed2',
  'type': 'text',
  'content': {
    'text': 'Hello!'
  },
  'reportUrl': 'https://example.com/reports'
};

messagebird.conversations.send(params, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
  php: `<?php
require './vendor/messagebird/php-rest-api/autoload.php';

$MessageBird = new \MessageBird\Client('YOUR_ACCESS_KEY');

// you need to get or start a conversation

$content = new \MessageBird\Objects\Conversation\Content();
$content->text = 'Hello!';

$message = new \MessageBird\Objects\Conversation\Message();
$message->content = $content;
$message->type = 'text';
$message->channelId = '619747f69cf940a98fb443140ce9aed2';

try {
    $msg = $MessageBird->conversationMessages->create($conversation->id, $message);
    print_r($msg);
} catch (\Exception $e) {
    echo sprintf("%s: %s", get_class($e), $e->getMessage());
}`,
  go: `client := messagebird.New("YOUR_ACCESS_KEY")

// you need to get or start a conversation

msg, err := conversation.CreateMessage(client, conv.ID, &conversation.MessageCreateRequest{
    ChannelID: "619747f69cf940a98fb443140ce9aed2",
    Content: &conversation.MessageContent{
        Text: "Hello!",
    },
    Type: conversation.MessageTypeText,
})
if err != nil {
    fmt.Println(err)
    return
}`,
  python: `import messagebird

client = messagebird.Client('YOUR_ACCESS_KEY')

# you need to get or start a conversation

message = client.conversation_create_message(conversation.id, {
    'channelId': '619747f69cf940a98fb443140ce9aed2',
    'type': 'text',
    'content': {
        'text': 'Hello!'
    }
})

print(message.__str__())`,
  ruby: `require 'pp'
require 'messagebird'

channel_id = '619747f69cf940a98fb443140ce9aed2'
to = '927832329'

client = MessageBird::Client.new('YOUR_ACCESS_KEY')

message = client.send_conversation_message(channel_id, to, type: 'text', content: { text: 'Hello!' })
pp message
    `,
  csharp: `using System;
using MessageBird;
using MessageBird.Exceptions;
using MessageBird.Net.ProxyConfigurationInjector;
using MessageBird.Objects;
using Newtonsoft.Json;

namespace Examples
{
    class SendMessage
    {
        const string YourAccessKey = "YOUR_ACCESS_KEY";
        const string ChannelId = "619747f69cf940a98fb443140ce9aed2";


        static void Main(string[] args)
        {
            IProxyConfigurationInjector proxyConfigurationInjector = null;

            Client client = Client.CreateDefault(YourAccessKey, proxyConfigurationInjector);

            // you need to get or start a conversation

            MessageBird.Objects.Conversations.ConversationMessageSendRequest message = new MessageBird.Objects.Conversations.ConversationMessageSendRequest();
            MessageBird.Objects.Conversations.Content content = new MessageBird.Objects.Conversations.Content();

            content.Text = "Hello!";

            message.Content = content;
            message.ChannelId = ChannelId;
            message.Type = MessageBird.Objects.Conversations.ContentType.Text;

            try
            {
                MessageBird.Objects.Conversations.ConversationMessage conversationMessage = client.SendConversationMessage(conversation.Id, message);
                var jsonString = JsonConvert.SerializeObject(
                        conversationMessage, Formatting.Indented,
                        new JsonConverter[] {});
                Console.WriteLine(jsonString);
            }
            catch (ErrorException e)
            {
                // Either the request fails with error descriptions from the endpoint.
                if (e.HasErrors)
                {
                    foreach (Error error in e.Errors)
                    {
                        Console.WriteLine("code: {0} description: '{1}' parameter: '{2}'", error.Code, error.Description, error.Parameter);
                    }
                }
                // or fails without error information from the endpoint, in which case the reason contains a 'best effort' description.
                if (e.HasReason)
                {
                    Console.WriteLine(e.Reason);
                }
            }
        }
    }
}`,
  java: `import com.messagebird.MessageBirdClient;
import com.messagebird.MessageBirdService;
import com.messagebird.MessageBirdServiceImpl;
import com.messagebird.exceptions.GeneralException;
import com.messagebird.exceptions.UnauthorizedException;
import com.messagebird.objects.conversations.*;


public class SendMessage {
    private static final String AccessKey = "YOUR_ACCESS_KEY";
    private static final String ChannelId = "619747f69cf940a98fb443140ce9aed2";

    public static void main(String[] args) {
        final MessageBirdService wsr = new MessageBirdServiceImpl(AccessKey);
        final MessageBirdClient messageBirdClient = new MessageBirdClient(wsr);

        ConversationContent content = new ConversationContent();
        content.setText("Hello!");

        ConversationMessageRequest request = new ConversationMessageRequest();

        request.setType(ConversationContentType.TEXT);
        request.setChannelId(ChannelId);
        request.setContent(content);

        try {
            // you will need to get or start a conversation

            ConversationMessage message = messageBirdClient.sendConversationMessage(conversation.getId(), request);
            System.out.println(message);
        } catch (GeneralException | UnauthorizedException exception) {
            exception.printStackTrace();
        }
    }
}`,
};

export const SEND_RESPONSE_EXAMPLE = {
  curl: `{
  "id": "2e15efafec384e1c82e9842075e87beb",
  "status": "accepted"
}`,
  node: `{
  "message": {
    "id": "2e15efafec384e1c82e9842075e87beb",
    "status": "accepted"
  }
}`,
  php: `MessageBird\Objects\Conversation\Message Object
(
    [id] => 3a9bc842f83142d98307933d7abf4cb4
    [conversationId] => a34679d85c934e1a8d3feeb0a3a17d45
    [channelId] => 619747f69cf940a98fb443140ce9aed2
    [direction] => sent
    [status] => pending
    [type] => text
    [content] => MessageBird\Objects\Conversation\Content Object
        (
            [audio] =>
            [file] =>
            [image] =>
            [location] =>
            [text] => Hello!
            [video] =>
            [hsm] =>
        )

    [to] =>
    [createdDatetime] => 2020-03-05T12:53:46.150855875Z
    [updatedDatetime] =>
)`,
  ruby: `#<MessageBird::ConversationMessage:0x0000a9221da6d618
 @fallback=nil,
 @id="a166e2880d034c19b9d8f07f12eb9355",
 @status="accepted">`,
  go: `&conversation.Message{
   ID:             "3a9bc842f83142d98307933d7abf4cb4",
   ConversationID: "a34679d85c934e1a8d3feeb0a3a17d45",
   ChannelID:      "619747f69cf940a98fb443140ce9aed2",
   Direction:      "sent",
   Status:         "pending",
   Type:           "text",
   Content:        conversation.MessageContent{
       Audio:    (*conversation.Audio)(nil),
       File:     (*conversation.File)(nil),
       Image:    (*conversation.Image)(nil),
       Location: (*conversation.Location)(nil),
       Video:    (*conversation.Video)(nil),
       Text:     "Hello!",
       HSM:      (*conversation.HSM)(nil),
   },
   CreatedDatetime: &time.Time{
       wall: 0x11eca243,
       ext:  63719009920,
       loc:  (*time.Location)(nil),
   },
   UpdatedDatetime: (*time.Time)(nil),
}`,
  python: `message id        : 3a9bc842f83142d98307933d7abf4cb4
channel id        : 619747f69cf940a98fb443140ce9aed2
direction         : sent
status            : pending
type              : text
content           : {'text': 'Hello!'}
created date time : 2020-03-05 13:03:11+00:00
updated date time : None
message id        : 3a9bc842f83142d98307933d7abf4cb4
channel id        : 619747f69cf940a98fb443140ce9aed2
direction         : sent
status            : pending
type              : text
content           : {'text': 'Hello!'}
created date time : 2020-03-05 13:03:11+00:00
updated date time : None`,
  csharp: `{
  "id": "3a9bc842f83142d98307933d7abf4cb4",
  "conversationId": "a34679d85c934e1a8d3feeb0a3a17d45",
  "channelId": "619747f69cf940a98fb443140ce9aed2",
  "direction": "sent",
  "status": "pending",
  "type": "text",
  "content": {
    "audio": null,
    "file": null,
    "hsm": null,
    "image": null,
    "location": null,
    "text": "Hello!",
    "video": null
  },
  "error": null,
  "createdDatetime": "2020-03-05T13:05:10.3356935Z",
  "updatedDatetime": null
}`,
  java: `ConversationMessage{id='3a9bc842f83142d98307933d7abf4cb4', conversationId='a34679d85c934e1a8d3feeb0a3a17d45', channelId='619747f69cf940a98fb443140ce9aed2', direction=sent, status=pending, type=text, content=ConversationContent{audio=null, file=null, hsm=null, image=null, location=null, text='Hello!', video=null}, createdDatetime=Mon Mar 09 16:47:01 CET 2020, updatedDatetime=null}`,
};

export const STATUS_UPDATE_PER_MESSAGE_EXAMPLE = {
  json: `{
  "type": "message.status",
  "message": {
    "id": "2e15efafec384e1c82e9842075e87beb",
    "status": "failed"
  },
  "error": {
    "code": 302,
    "description": "The contact is not registered on WhatsApp"
  },
  "workspaceId": 3917675
}`,
};

export const FALLBACK_REQUEST_EXAMPLE = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/send" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "to":"+31612345678",
    "from":"619747f69cf940a98fb443140ce9aed2",
    "type":"text",
    "content":{
      "text":"Hello!"
    },
    "reportUrl":"https://example.com/reports"
    "fallback": {
      "from": "2ecea8ee6c564bb4ab15929c44527687"
      "after": "5m"
    }
  }'`,
};

export const FALLBACK_RESPONSE = {
  json: `{
  "id": "2e15efafec384e1c82e9842075e87beb",
  "status": "accepted"
  "fallback": {
    "id": "a5a66361dc0b4e5d8d2da249753fa8b5",
  }
}`,
};

export const FALLBACK_STATUS_UPDATE_EXAMPLE = {
  json: `{
  "type": "message.fallbackTriggered",
  "message": {
    "id": "5d76d378e5eb4af2b9e98ac659781dfd",
  },
  "fallback": {
    "id": "2fcb9be1131f4f409fae0ead9ed54e81",
  }
}`,
};

export const LIST_CONVERSATIONS_ENDPOINT = {
  bash: `GET /v1/conversations`,
};

export const START_CONVERSATION_ENDPOINT = {
  bash: `POST /conversations/start`,
};

export const START_CONVERSATION_REQUEST_EXAMPLE = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/conversations/start" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "to": "+31612345678",
    "channelId": "619747f69cf940a98fb443140ce9aed2",
    "type": "text",
    "content": {
      "text": "Hello!"
    },
    "source": {
      "foo": "bar"
    }
  }'`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

var params = {
  'to': '+31612345678',
  'channelId': '619747f69cf940a98fb443140ce9aed2',
  'type': 'text',
  'content': { 'text': 'Hello!' },
  'source': { 'foo': 'bar' }
};

messagebird.conversations.start(params, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
  php: `require './vendor/messagebird/php-rest-api/autoload.php';

$MessageBird = new \MessageBird\Client('YOUR_ACCESS_KEY');

$content = new \MessageBird\Objects\Conversation\Content();
$content->text = 'Hello!';

$message = new \MessageBird\Objects\Conversation\Message();
$message->content = $content;
$message->to = '927832329';
$message->type = 'text';
$message->channelId = '619747f69cf940a98fb443140ce9aed2';

try {
    $conversation = $MessageBird->conversations->start($message);
    var_dump($conversation);
} catch (\Exception $e) {
    echo sprintf("%s: %s", get_class($e), $e->getMessage());
}`,
  go: `client := messagebird.New("YOUR_ACCESS_KEY")

conv, err := conversation.Start(client, &conversation.StartRequest{
	ChannelID: "16bb8e90ae884914bdb883326cce029e",
	To:        "727840328",
	Content: &conversation.MessageContent{
		Text: "Hello from GO",
	},
	Type: conversation.MessageTypeText,
})

fmt.Println(conv, err)`,
  python: `import messagebird

client = messagebird.Client('YOUR_ACCESS_KEY')

conversation = client.conversation_start({
    'channelId': '619747f69cf940a98fb443140ce9aed2',
    'to': '927832329',
    'type': 'text',
    'content': {
        'text': 'Hello!'
    }
})

print('The following information was returned as a Conversation object:')
print(conversation)
    `,
  ruby: `require 'pp'
require 'messagebird'

channel_id = '619747f69cf940a98fb443140ce9aed2'
to = '927832329'

client = MessageBird::Client.new('YOUR_ACCESS_KEY')

conversation = client.start_conversation(to, channel_id, type: 'text', content: { text: 'Hello!' })
pp conversation
`,
  csharp: `using System;
using MessageBird;
using MessageBird.Exceptions;
using MessageBird.Net.ProxyConfigurationInjector;
using MessageBird.Objects;

namespace Examples
{
    class StartConversation
    {
        const string YourAccessKey = "YOUR_ACCESS_KEY";
        const string To = "927832329";
        const string ChannelId = "619747f69cf940a98fb443140ce9aed2";

        static void Main(string[] args)
        {
            IProxyConfigurationInjector proxyConfigurationInjector = null;

            Client client = Client.CreateDefault(YourAccessKey, proxyConfigurationInjector);

            MessageBird.Objects.Conversations.ConversationStartRequest message = new MessageBird.Objects.Conversations.ConversationStartRequest();
            MessageBird.Objects.Conversations.Content content = new MessageBird.Objects.Conversations.Content();

            content.Text = "Hello!";

            message.To = To;
            message.Content = content;
            message.ChannelId = ChannelId;
            message.Type = MessageBird.Objects.Conversations.ContentType.Text;

            try
            {
                MessageBird.Objects.Conversations.Conversation conversation = client.StartConversation(message);
                var jsonString = JsonConvert.SerializeObject(
                        conversation, Formatting.Indented,
                        new JsonConverter[] {});
                Console.WriteLine(jsonString);
            }
            catch (ErrorException e)
            {
                // Either the request fails with error descriptions from the endpoint.
                if (e.HasErrors)
                {
                    foreach (Error error in e.Errors)
                    {
                        Console.WriteLine("code: {0} description: '{1}' parameter: '{2}'", error.Code, error.Description, error.Parameter);
                    }
                }
                // or fails without error information from the endpoint, in which case the reason contains a 'best effort' description.
                if (e.HasReason)
                {
                    Console.WriteLine(e.Reason);
                }
            }

            Console.WriteLine("Press any key to continue...");
            Console.ReadKey();
        }
    }
}`,
  java: `import com.messagebird.MessageBirdClient;
import com.messagebird.MessageBirdService;
import com.messagebird.MessageBirdServiceImpl;
import com.messagebird.exceptions.GeneralException;
import com.messagebird.exceptions.UnauthorizedException;
import com.messagebird.objects.conversations.*;


public class StartConversation {
    private static final String AccessKey = "YOUR_ACCESS_KEY";
    private static final String To = "927832329";
    private static final String ChannelId = "619747f69cf940a98fb443140ce9aed2";

    public static void main(String[] args) {
        final MessageBirdService wsr = new MessageBirdServiceImpl(AccessKey);
        final MessageBirdClient messageBirdClient = new MessageBirdClient(wsr);

        ConversationContent conversationContent = new ConversationContent();
        conversationContent.setText("Hello!");

        ConversationStartRequest request = new ConversationStartRequest(
                To,
                ConversationContentType.TEXT,
                conversationContent,
                ChannelId
        );
        try {
            Conversation conversation = messageBirdClient.startConversation(request);
            System.out.println(conversation);
        } catch (GeneralException | UnauthorizedException exception) {
            exception.printStackTrace();
        }
    }
}`,
};

export const START_CONVERSATION_RESPONSE_EXAMPLE = {
  json: `{
  "id": "2e15efafec384e1c82e9842075e87beb",
  "contactId": "a621095fa44947a28b441cfdf85cb802",
  "contact": {
  "id": "a621095fa44947a28b441cfdf85cb802",
  "href": "https://rest.messagebird.com/1/contacts/a621095fa44947a28b441cfdf85cb802",
  "msisdn": 316123456789,
  "firstName": "Jen",
  "lastName": "Smith",
  "customDetails": {
    "custom1": null,
    "custom2": null,
    "custom3": null,
    "custom4": null
  },
  "createdDatetime": "2018-06-03T20:06:03Z",
  "updatedDatetime": null
  },
  "channels": [
  {
    "id": "853eeb5348e541a595da93b48c61a1ae",
    "name": "SMS",
    "platformId": "sms",
    "status": "active",
    "createdDatetime": "2018-08-28T11:56:57Z",
    "updatedDatetime": "2018-08-29T08:16:33Z"
  },
  {
    "id": "619747f69cf940a98fb443140ce9aed2",
    "name": "My WhatsApp",
    "platformId": "whatsapp",
    "status": "active",
    "createdDatetime": "2018-08-28T11:56:57Z",
    "updatedDatetime": "2018-08-29T08:16:33Z"
  },
  ],
  "status": "active",
  "createdDatetime": "2018-08-13T09:17:22Z",
  "updatedDatetime": "2018-08-29T07:35:48Z",
  "lastReceivedDatetime": "2018-08-29T07:35:48Z",
  "lastUsedChannelId": "619747f69cf940a98fb443140ce9aed2",
  "lastUsedPlatformId": "whatsapp",
  "messages": {
  "totalCount": 24,
  "href": "https://conversations.messagebird.com/v1/conversations/2e15efafec384e1c82e9842075e87beb/messages",
  "lastMessageId": "9d5d5921f5b34f8db415a2397eb762f9",
  }
}`,
  php: `MessageBird\Objects\Conversation\Conversation Object
(
    [id] => 347677d854936e1a8d32eeb2a3a09d17
    [href] =>
    [contact] => MessageBird\Objects\Conversation\Contact Object
        (
            [id] => 2e9f5a2b8d8e4e34803691277c2672a4
            [href] => https://contacts.messagebird.com/v2/contacts/2e9f5a2b8d8e4e34803691277c2672a4
            [msisdn] =>
            [firstName] => Example
            [lastName] => Customer
            [customDetails] => Array
                (
                )

            [createdDatetime] => 2020-03-03T14:59:49Z
            [updatedDatetime] => 2020-03-03T14:59:50Z
        )

    [channels] => Array
        (
            [0] => MessageBird\Objects\Conversation\Channel Object
                (
                    [id] => 18ab8e91ae864915bdb282326cce130e
                    [name] => MessageBird Test
                    [platformId] => telegram
                    [status] => active
                    [createdDatetime] => 2020-03-03T13:46:33Z
                    [updatedDatetime] => 2020-03-03T14:58:19Z
                )

        )

    [status] => active
    [messages] => MessageBird\Objects\Conversation\MessageReference Object
        (
            [href] => https://conversations.messagebird.com/v1/conversations/347677d854936e1a8d32eeb2a3a09d17/messages
            [totalCount] => 13
        )

    [lastUsedChannelId] => 619747f69cf940a98fb443140ce9aed2
    [lastUsedPlatformId] => whatsapp
    [lastReceivedDatetime] => 2020-03-04T13:37:10.817119144Z
    [createdDatetime] => 2020-03-03T14:59:48Z
    [updatedDatetime] => 2020-03-04T13:37:10.82559585Z
)`,
  ruby: `#<MessageBird::Conversation:0x00007fc87e0e8320
 @channels=
  [#<MessageBird::ConversationChannel:0x0000a9c87e128d1f
    @createdDatetime=2020-03-03 13:46:33 UTC,
    @id="a6bb8e9fae8849c4bdb8b3e261ce0291",
    @name="MessageBird Test",
    @platformId="telegram",
    @status="active",
    @updatedDatetime=2020-03-03 14:58:19 UTC>],
 @contact=
  #<MessageBird::Contact:0x0000afc81e0e8231
   @createdDatetime=2020-03-03 14:59:49 UTC,
   @customDetails=#<MessageBird::CustomDetails:0x00007fc87e123f38>,
   @firstName="Example",
   @href=
    "https://contacts.messagebird.com/v2/contacts/a18f501b848e4e148a36d1273c2670a1",
   @id="a18f501b848e4e148a36d1273c2670a1",
   @lastName="Customer",
   @msisdn=nil,
   @updatedDatetime=2020-03-03 14:59:50 UTC>,
 @contactId="a18f501b848e4e148a36d1273c2670a1",
 @createdDatetime=2020-03-03 14:59:48 UTC,
 @id="a6bb8e9fae8849c4bdb8b3e261ce0291",
 @lastReceivedDatetime=2020-03-05 11:02:17 UTC,
 @lastUsedChannelId="619747f69cf940a98fb443140ce9aed2",
 @lastUsedPlatformId="whatsapp",
 @messages=
  #<MessageBird::MessageReference:0x0000a1c87e1b3120
   @href=
    "https://conversations.messagebird.com/v1/conversations/144a7cd8549d4e1a8d311eb0a5a07d15/messages",
   @totalCount=60>,
 @status="active",
 @updatedDatetime=2020-03-05 11:02:17 UTC>`,
  csharp: `{
  "id": 2e9f5a2b8d8e4e34803691277c2672a4",
  "contactId": "6e4f6a0b6d9e4e24873691271c2675a2",
  "contact": {
    "id": "9e8f5a1b8d8e4e44803691273c2670a2",
    "href": "https://contacts.messagebird.com/v2/contacts/6e4f6a0b6d9e4e24873691271c2675a2",
    "msisdn": null,
    "firstName": "Example",
    "lastName": "Customer",
    "customDetails": {},
    "createdDatetime": "2020-03-03T14:59:49Z",
    "updatedDatetime": "2020-03-03T14:59:50Z"
  },
  "channels": [
    {
      "id": "18ab8e91ae864915bdb282326cce130e",
      "name": "MessageBird Test",
      "status": "active",
      "createdDatetime": "2020-03-03T13:46:33Z",
      "updatedDatetime": "2020-03-03T14:58:19Z"
    }
  ],
  "messages": {
    "href": "https://conversations.messagebird.com/v1/conversations/347677d854936e1a8d32eeb2a3a09d17/messages",
    "totalCount": 14
  },
  "status": "active",
  "createdDatetime": "2020-03-03T14:59:48Z",
  "updatedDatetime": "2020-03-04T13:40:21.5694635Z",
  "lastReceivedDatetime": "2020-03-04T13:40:21.5370337Z",
  "lastUsedChannelId": "619747f69cf940a98fb443140ce9aed2",
  "lastUsedPlatformId": "whatsapp",
}`,
  go: `conversation.Conversation{
   ID:        "2e9f5a2b8d8e4e34803691277c2672a4",
   ContactID: "6e4f6a0b6d9e4e24873691271c2675a2",
   Contact:   &conversation.Contact{
       ID:            "2e9f5a2b8d8e4e34803691277c2672a4",
       Href:          "https://contacts.messagebird.com/v2/contacts/6e4f6a0b6d9e4e24873691271c2675a2",
       MSISDN:        "",
       FirstName:     "Example",
       LastName:      "Customer",
       CustomDetails: {
       },
       CreatedAt: (*time.Time)(nil),
       UpdatedAt: (*time.Time)(nil),
   },
   LastUsedChannelID: "619747f69cf940a98fb443140ce9aed2",
   LastUsedPlatform: "whatsapp",
   Channels:          {
       &conversation.Channel{
           ID:              "2e9f5a2b8d8e4e34803691277c2672a4",
           Name:            "MessageBird Test",
           PlatformID:      "telegram",
           Status:          "active",
           CreatedDatetime: &time.Time{
               wall: 0x0,
               ext:  63718839993,
               loc:  (*time.Location)(nil),
           },
           UpdatedDatetime: &time.Time{
               wall: 0x0,
               ext:  63718844299,
               loc:  (*time.Location)(nil),
           },
       },
   },
   Messages:        &conversation.MessagesCount{HRef:"https://conversations.messagebird.com/v1/conversations/347677d854936e1a8d32eeb2a3a09d17/messages", TotalCount:16},
   Status:          "active",
   CreatedDatetime: time.Time{
       wall: 0x0,
       ext:  63718844388,
       loc:  (*time.Location)(nil),
   },
   UpdatedDatetime: &time.Time{
       wall: 0x9001abc,
       ext:  63718927724,
       loc:  (*time.Location)(nil),
   },
   LastReceivedDatetime: &time.Time{
       wall: 0x8a71dac,
       ext:  63718927724,
       loc:  (*time.Location)(nil),
   },
}`,
  python: `id                   : 744673d854934e1a8d31eeb0a3a07d15
contact id           : 9e8f5a1b8d8e4e44803691273c2670a2
last used channel id : 16bb8e90ae884914bdb883326cce029e
message total count  : 23
status               : active
created date time    : 2020-03-03 14:59:48+00:00
updated date time    : 2020-03-04 15:10:01+00:00
last received date   : 2020-03-04 15:10:01+00:00`,
  java: `Conversation{id='744673d854934e1a8d31eeb0a3a07d15', contactId='9e8f5a1b8d8e4e44803691273c2670a2', contact=ConversationContact{id='9e8f5a1b8d8e4e44803691273c2670a2', href='https://contacts.messagebird.com/v2/contacts/9e8f5a1b8d8e4e44803691273c2670a2', msisdn='null', firstName='Example', lastName='Customer', customDetails={}, createdDatetime=Tue Mar 03 15:59:49 CET 2020, updatedDatetime=Tue Mar 03 15:59:50 CET 2020}, channels=[ConversationChannel{id='16bb8e90ae884914bdb883326cce029e', name='MessageBird', status=active, createdDatetime=Tue Mar 03 14:46:33 CET 2020, updatedDatetime=Tue Mar 03 15:58:19 CET 2020}], messages=MessageReference{href='https://conversations.messagebird.com/v1/conversations/744673d854934e1a8d31eeb0a3a07d15/messages', totalCount=106}, status=active, createdDatetime=Tue Mar 03 15:59:48 CET 2020, updatedDatetime=Mon Mar 09 15:56:48 CET 2020, lastReceivedDatetime=Mon Mar 09 15:56:48 CET 2020, lastUsedChannelId='16bb8e90ae884914bdb883326cce029e'}`,
};

export const LIST_CONVERSATIONS_REQUEST_EXAMPLE = {
  curl: `curl -X GET "https://conversations.messagebird.com/v1/conversations" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM"`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

messagebird.conversations.list(20, 0, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
  go: `client := messagebird.New("YOUR_ACCESS_KEY")

conversations, err := conversation.List(client, nil)
if err != nil {
    fmt.Println(err)
    return
}

fmt.Println(conversations)`,
  python: `import messagebird

client = messagebird.Client('YOUR_ACCESS_KEY')

conversations = client.conversation_list()
print(conversations.__str__())`,
  php: `<?php
require './vendor/messagebird/php-rest-api/autoload.php';

$MessageBird = new \MessageBird\Client('YOUR_ACCESS_KEY');

$conversations = $MessageBird->conversations->getList();
print_r($conversations);`,
  csharp: `using System;
using MessageBird;
using MessageBird.Exceptions;
using MessageBird.Net.ProxyConfigurationInjector;
using MessageBird.Objects;
using Newtonsoft.Json;

namespace Examples
{
    class ListConversations
    {
        const string YourAccessKey = "YOUR_ACCESS_KEY";

        static void Main(string[] args)
        {
            IProxyConfigurationInjector proxyConfigurationInjector = null;

            Client client = Client.CreateDefault(YourAccessKey, proxyConfigurationInjector);

            try
            {
                MessageBird.Objects.Conversations.ConversationList conversations = client.ListConversations();

                var jsonString = JsonConvert.SerializeObject(
                        conversations, Formatting.Indented,
                        new JsonConverter[] {});
                Console.WriteLine(jsonString);
            }
            catch (ErrorException e)
            {
                // Either the request fails with error descriptions from the endpoint.
                if (e.HasErrors)
                {
                    foreach (Error error in e.Errors)
                    {
                        Console.WriteLine("code: {0} description: '{1}' parameter: '{2}'", error.Code, error.Description, error.Parameter);
                    }
                }
                // or fails without error information from the endpoint, in which case the reason contains a 'best effort' description.
                if (e.HasReason)
                {
                    Console.WriteLine(e.Reason);
                }
            }
        }
    }
}`,
  ruby: `require 'pp'
require 'messagebird'

client = MessageBird::Client.new('YOUR_ACCESS_KEY')

conversations = client.conversation_list()
pp conversations`,
  java: `import com.messagebird.MessageBirdClient;
import com.messagebird.MessageBirdService;
import com.messagebird.MessageBirdServiceImpl;
import com.messagebird.exceptions.GeneralException;
import com.messagebird.exceptions.UnauthorizedException;
import com.messagebird.objects.conversations.*;

public class ListConversations {
    private static final String AccessKey = "YOUR_ACCESS_KEY";

    public static void main(String[] args) {
        final MessageBirdService wsr = new MessageBirdServiceImpl(AccessKey);
        final MessageBirdClient messageBirdClient = new MessageBirdClient(wsr);

        try {
            ConversationList conversations = messageBirdClient.listConversations();
            System.out.println(conversations);
        } catch (GeneralException | UnauthorizedException exception) {
            exception.printStackTrace();
        }
    }
}`,
};

export const LIST_CONVERSATIONS_RESPONSE_EXAMPLE = {
  json: `{
  "offset": 0,
  "limit": 20,
  "count": 2,
  "totalCount": 2,
  "items": [
  {
    "id": "fbbdde79129f45e3a179458a91e2ead6",
    "contactId": "03dfc27855c3475b953d6200a1b7eaf7",
    "contact": {
    "id": "03dfc27855c3475b953d6200a1b7eaf7",
    "href": "https://rest.messagebird.com/contacts/03dfc27855c3475b953d6200a1b7eaf7",
    "msisdn": 31612345678,
    "firstName": "John",
    "lastName": "Doe",
    "customDetails": {
      "custom1": null,
      "custom2": null,
      "custom3": null,
      "custom4": null
    },
    "createdDatetime": "2018-08-01T09:45:52Z",
    "updatedDatetime": "2018-08-28T12:37:35Z"
    },
    "channels": [
    {
      "id": "619747f69cf940a98fb443140ce9aed2",
      "name": "My WhatsApp",
      "platformId": "whatsapp",
      "status": "active",
      "createdDatetime": "2018-08-28T11:56:57Z",
      "updatedDatetime": "2018-08-29T08:16:33Z"
    },
    ],
    "status": "active",
    "createdDatetime": "2018-08-29T08:52:54Z",
    "updatedDatetime": "2018-08-29T08:52:54Z",
    "lastReceivedDatetime": "2018-08-29T08:52:54Z",
    "lastUsedChannelId": "619747f69cf940a98fb443140ce9aed2",
    "lastUsedPlatformId": "whatsapp",
    "messages": {
    "totalCount": 10,
    "href": "https://conversations.messagebird.com/v1/conversations/fbbdde79129f45e3a179458a91e2ead6/messages"
    }
  },
  {
    "id": "2e15efafec384e1c82e9842075e87beb",
    "contactId": "a621095fa44947a28b441cfdf85cb802",
    "contact": {
    "id": "a621095fa44947a28b441cfdf85cb802",
    "href": "https://rest.messagebird.com/1/contacts/a621095fa44947a28b441cfdf85cb802",
    "msisdn": 316123456789,
    "firstName": "Jen",
    "lastName": "Smith",
    "customDetails": {
      "custom1": null,
      "custom2": null,
      "custom3": null,
      "custom4": null
    },
    "createdDatetime": "2018-06-03T20:06:03Z",
    "updatedDatetime": null
    },
    "channels": [
    {
      "id": "853eeb5348e541a595da93b48c61a1ae",
      "name": "SMS",
      "platformId": "sms",
      "status": "active",
      "createdDatetime": "2018-08-28T11:56:57Z",
      "updatedDatetime": "2018-08-29T08:16:33Z"
    },
    {
      "id": "619747f69cf940a98fb443140ce9aed2",
      "name": "My WhatsApp",
      "platformId": "whatsapp",
      "status": "active",
      "createdDatetime": "2018-08-28T11:56:57Z",
      "updatedDatetime": "2018-08-29T08:16:33Z"
    }
    ],
    "status": "active",
    "createdDatetime": "2018-08-13T09:17:22Z",
    "updatedDatetime": "2018-08-29T07:35:48Z",
    "lastReceivedDatetime": "2018-08-29T07:35:48Z",
    "lastUsedChannelId": "853eeb5348e541a595da93b48c61a1ae",
    "lastUsedPlatformId": "sms",
    "messages": {
    "totalCount": 23,
    "href": "https://conversations.messagebird.com/v1/conversations/2e15efafec384e1c82e9842075e87beb/messages"
    }
  },
  ]
}`,
  php: `MessageBird\Objects\BaseList Object
(
    [limit] => 10
    [offset] => 0
    [count] => 2
    [totalCount] => 9
    [links] => Array
        (
            [first] =>
            [previous] =>
            [next] =>
            [last] =>
        )

    [items] => Array
        (
            [0] => MessageBird\Objects\Conversation\Conversation Object
                (
                    [id] => a44b73d8c493de1a8de1eeb7a3a02d15
                    [href] =>
                    [contact] => MessageBird\Objects\Conversation\Contact Object
                        (
                            [id] => fe8a5a1b8dbe4ea480d691273c2170a0
                            [href] => https://contacts.messagebird.com/v2/contacts/fe8a5a1b8dbe4ea480d691273c2170a0
                            [msisdn] =>
                            [firstName] => Example
                            [lastName] => Customer
                            [customDetails] => Array
                                (
                                )

                            [createdDatetime] => 2020-03-03T14:59:49Z
                            [updatedDatetime] => 2020-03-03T14:59:50Z
                        )

                    [channels] => Array
                        (
                            [0] => MessageBird\Objects\Conversation\Channel Object
                                (
                                    [id] => a6bb8e10ae384914bdbc83356cce0291
                                    [name] => MessageBird Test
                                    [platformId] => telegram
                                    [status] => active
                                    [createdDatetime] => 2020-03-03T13:46:33Z
                                    [updatedDatetime] => 2020-03-03T14:58:19Z
                                )

                        )

                    [status] => active
                    [messages] => MessageBird\Objects\Conversation\MessageReference Object
                        (
                            [href] => https://conversations.messagebird.com/v1/conversations/a44b73d8c493de1a8de1eeb7a3a02d15/messages
                            [totalCount] => 102
                        )

                    [lastUsedChannelId] => a6bb8e10ae384914bdbc83356cce0291
                    [lastUsedPlatformId] => telegram
                    [lastReceivedDatetime] => 2020-03-05T15:31:23.200954713Z
                    [createdDatetime] => 2020-03-03T14:59:48Z
                    [updatedDatetime] => 2020-03-05T15:31:23.207428669Z
                )

            [1] => MessageBird\Objects\Conversation\Conversation Object
                (
                    [id] => 132fc9d51a4549a692d1ea629b318c81
                    [href] =>
                    [contact] => MessageBird\Objects\Conversation\Contact Object
                        (
                            [id] => b050535e01b848bf8155c2d9103c2089
                            [href] => https://contacts.messagebird.com/v2/contacts/b050535e01b848bf8155c2d9103c2089
                            [msisdn] =>
                            [firstName] =>
                            [lastName] =>
                            [customDetails] => Array
                                (
                                )

                            [createdDatetime] => 2020-03-03T15:00:24Z
                            [updatedDatetime] => 2020-03-03T15:00:24Z
                        )

                    [channels] => Array
                        (
                            [0] => MessageBird\Objects\Conversation\Channel Object
                                (
                                    [id] => a6bb8e10ae384914bdbc83356cce0291
                                    [name] => MessageBird Test
                                    [platformId] => telegram
                                    [status] => active
                                    [createdDatetime] => 2020-03-03T13:46:33Z
                                    [updatedDatetime] => 2020-03-03T14:58:19Z
                                )

                        )

                    [status] => active
                    [messages] => MessageBird\Objects\Conversation\MessageReference Object
                        (
                            [href] => https://conversations.messagebird.com/v1/conversations/a6bb8e10ae384914bdbc83356cce0291/messages
                            [totalCount] => 1
                        )

                    [lastUsedChannelId] => a6bb8e10ae384914bdbc83356cce0291
                    [lastUsedPlatformId] => telegram
                    [lastReceivedDatetime] => 2020-03-03T15:00:25.99823011Z
                    [createdDatetime] => 2020-03-03T15:00:24Z
                    [updatedDatetime] => 2020-03-03T15:00:26.00229742Z
                )

        )

)`,
  csharp: `{
  "limit": 2,
  "offset": 0,
  "count": 2,
  "totalCount": 9,
  "links": null,
  "items": [
    {
      "id": "c92c0babdc764d8674bcea14a55d867d,
      "contactId": "ef39fbf69170b58787ce4e574db9d842",
      "contact": {
        "id": "ef39fbf69170b58787ce4e574db9d842",
        "href": "https://contacts.messagebird.com/v2/contacts/ef39fbf69170b58787ce4e574db9d842",
        "msisdn": null,
        "firstName": "Example",
        "lastName": "Customer",
        "customDetails": {},
        "createdDatetime": "2020-03-03T14:59:49Z",
        "updatedDatetime": "2020-03-03T14:59:50Z"
      },
      "channels": [
        {
          "id": "3ab1faad513e753501264a716622ba06",
          "name": "MessageBird Test",
          "status": "active",
          "createdDatetime": "2020-03-03T13:46:33Z",
          "updatedDatetime": "2020-03-03T14:58:19Z"
        }
      ],
      "messages": {
        "href": "https://conversations.messagebird.com/v1/conversations/c92c0babdc764d8674bcea14a55d867d/messages",
        "totalCount": 102
      },
      "status": "active",
      "createdDatetime": "2020-03-03T14:59:48Z",
      "updatedDatetime": "2020-03-05T15:31:23.2074287Z",
      "lastReceivedDatetime": "2020-03-05T15:31:23.2009547Z",
      "lastUsedChannelId": "3ab1faad513e753501264a716622ba06",
      "lastUsedPlatformId": "sms"
    },
    {
      "id": "45992a02f948fe230c3265ae8175b91b",
      "contactId": "ed692e027c43c5f0f87039052e702a0b",
      "contact": {
        "id": "ed692e027c43c5f0f87039052e702a0b",
        "href": "https://contacts.messagebird.com/v2/contacts/ed692e027c43c5f0f87039052e702a0b",
        "msisdn": null,
        "firstName": "",
        "lastName": "",
        "customDetails": {},
        "createdDatetime": "2020-03-03T15:00:24Z",
        "updatedDatetime": "2020-03-03T15:00:24Z"
      },
      "channels": [
        {
          "id": "3ab1faad513e753501264a716622ba06",
          "name": "MessageBird Test",
          "status": "active",
          "createdDatetime": "2020-03-03T13:46:33Z",
          "updatedDatetime": "2020-03-03T14:58:19Z"
        }
      ],
      "messages": {
        "href": "https://conversations.messagebird.com/v1/conversations/45992a02f948fe230c3265ae8175b91b/messages",
        "totalCount": 1
      },
      "status": "active",
      "createdDatetime": "2020-03-03T15:00:24Z",
      "updatedDatetime": "2020-03-03T15:00:26.0022974Z",
      "lastReceivedDatetime": "2020-03-03T15:00:25.9982301Z",
      "lastUsedChannelId": "3ab1faad513e753501264a716622ba06",
      "lastUsedPlatformId": "sms"
    }
  ],
  "Id": ""
}`,
  ruby: `#<List:0x00007f899e1c2ad0
 @count=2,
 @items=
  [#<MessageBird::Conversation:0x00002f8b9e1c19b3
    @channels=
     [#<MessageBird::ConversationChannel:0x00001b391e1ebc8d
       @createdDatetime=2020-03-03 13:46:33 UTC,
       @id="3ab1faad513e753501264a716622ba06",
       @name="MessageBird Test",
       @platformId="telegram",
       @status="active",
       @updatedDatetime=2020-03-03 14:58:19 UTC>],
    @contact=
     #<MessageBird::Contact:0x00001b89921a29d8
      @createdDatetime=2020-03-03 14:59:49 UTC,
      @customDetails=#<MessageBird::CustomDetails:0x0000ab199e9c2671>,
      @firstName="Example",
      @href=
       "https://contacts.messagebird.com/v2/contacts/ed692e027c43c5f0f87039052e702a0b",
      @id="ed692e027c43c5f0f87039052e702a0b",
      @lastName="Customer",
      @msisdn=nil,
      @updatedDatetime=2020-03-03 14:59:50 UTC>,
    @contactId="ed692e027c43c5f0f87039052e702a0b",
    @createdDatetime=2020-03-03 14:59:48 UTC,
    @id="c92c0babdc764d8674bcea14a55d867d",
    @lastReceivedDatetime=2020-03-05 15:31:23 UTC,
    @lastUsedChannelId="3ab1faad513e753501264a716622ba06",
    @lastUsedPlatformId="telegram",
    @messages=
     #<MessageBird::MessageReference:0x00001a89901d31ee
      @href=
       "https://conversations.messagebird.com/v1/conversations/d818fdda9b607de69729f9e602ed56ef/messages",
      @totalCount=102>,
    @status="active",
    @updatedDatetime=2020-03-05 15:31:23 UTC>,
   #<MessageBird::Conversation:0x00007f199e1d2e71
    @channels=
     [#<MessageBird::ConversationChannel:0x00001ab99e1d28b1
       @createdDatetime=2020-03-03 13:46:33 UTC,
       @id="885a6b2c844af5357d89a5648a146436",
       @name="MessageBird Test",
       @platformId="telegram",
       @status="active",
       @updatedDatetime=2020-03-03 14:58:19 UTC>],
    @contact=
     #<MessageBird::Contact:0x00001f819e1dedd0
      @createdDatetime=2020-03-03 15:00:24 UTC,
      @customDetails=#<MessageBird::CustomDetails:0x00001f819e1d3160>,
      @firstName="",
      @href=
       "https://contacts.messagebird.com/v2/contacts/0f916387bd50c1587e12580a6589c3a9",
      @id="12ac553189bd590c8b8ecced240baa13",
      @lastName="",
      @msisdn=nil,
      @updatedDatetime=2020-03-03 15:00:24 UTC>,
    @contactId="9bb86875e9e4f3d935221d0943fa04c8",
    @createdDatetime=2020-03-03 15:00:24 UTC,
    @id="a7fdf9e5ff3f993067e504a8c29af55b",
    @lastReceivedDatetime=2020-03-03 15:00:25 UTC,
    @lastUsedChannelId="885a6b2c844af5357d89a5648a146436",
    @lastUsedPlatformId="telegram",
    @messages=
     #<MessageBird::MessageReference:0x0000af8a9ea03f51
      @href=
       "https://conversations.messagebird.com/v1/conversations/6b5dd13a782bc591ad1efab8d4088cf7/messages",
      @totalCount=1>,
    @status="active",
    @updatedDatetime=2020-03-03 15:00:26 UTC>],
 @limit=10,
 @offset=0,
 @totalCount=2,
 @type=MessageBird::Conversation>`,
  go: `&conversation.ConversationList{
   Offset:     0,
   Limit:      10,
   Count:      2,
   TotalCount: 2,
   Items:      {
       &conversation.Conversation{
           ID:        "c92c0babdc764d8674bcea14a55d867d",
           ContactID: "ef39fbf69170b58787ce4e574db9d842",
           Contact:   &conversation.Contact{
               ID:            "ef39fbf69170b58787ce4e574db9d842",
               Href:          "https://contacts.messagebird.com/v2/contacts/ef39fbf69170b58787ce4e574db9d842",
               MSISDN:        "",
               FirstName:     "Example",
               LastName:      "Customer",
               CustomDetails: {
               },
               CreatedAt: (*time.Time)(nil),
               UpdatedAt: (*time.Time)(nil),
           },
           LastUsedChannelID: "45992a02f948fe230c3265ae8175b91b",
           LastUsedPlatformID: "telegram",
           Channels:          {
               &conversation.Channel{
                   ID:              "45992a02f948fe230c3265ae8175b91b",
                   Name:            "MessageBird Test",
                   PlatformID:      "telegram",
                   Status:          "active",
                   CreatedDatetime: &time.Time{
                       wall: 0x0,
                       ext:  63718839993,
                       loc:  (*time.Location)(nil),
                   },
                   UpdatedDatetime: &time.Time{
                       wall: 0x0,
                       ext:  63718844299,
                       loc:  (*time.Location)(nil),
                   },
               },
           },
           Messages:        &conversation.MessagesCount{HRef:"https://conversations.messagebird.com/v1/conversations/c92c0babdc764d8674bcea14a55d867d/messages", TotalCount:102},
           Status:          "active",
           CreatedDatetime: time.Time{
               wall: 0x0,
               ext:  63718844388,
               loc:  (*time.Location)(nil),
           },
           UpdatedDatetime: &time.Time{
               wall: 0xc5d1c3d,
               ext:  63719019083,
               loc:  (*time.Location)(nil),
           },
           LastReceivedDatetime: &time.Time{
               wall: 0xbfa5359,
               ext:  63719019083,
               loc:  (*time.Location)(nil),
           },
       },
       &conversation.Conversation{
           ID:        "c92c0babdc764d8674bcea14a55d867d",
           ContactID: "ef39fbf69170b58787ce4e574db9d842",
           Contact:   &conversation.Contact{
               ID:            "ef39fbf69170b58787ce4e574db9d842",
               Href:          "https://contacts.messagebird.com/v2/contacts/ef39fbf69170b58787ce4e574db9d842",
               MSISDN:        "",
               FirstName:     "Example",
               LastName:      "Customer",
               CustomDetails: {
               },
               CreatedAt: (*time.Time)(nil),
               UpdatedAt: (*time.Time)(nil),
           },
           LastUsedChannelID: "45992a02f948fe230c3265ae8175b91b",
           LastUsedPlatformID: "telegram",
           Channels:          {
               &conversation.Channel{
                   ID:              "45992a02f948fe230c3265ae8175b91b",
                   Name:            "MessageBird Test",
                   PlatformID:      "telegram",
                   Status:          "active",
                   CreatedDatetime: &time.Time{
                       wall: 0x0,
                       ext:  63718839993,
                       loc:  (*time.Location)(nil),
                   },
                   UpdatedDatetime: &time.Time{
                       wall: 0x0,
                       ext:  63718844299,
                       loc:  (*time.Location)(nil),
                   },
               },
           },
           Messages:        &conversation.MessagesCount{HRef:"https://conversations.messagebird.com/v1/conversations/c92c0babdc764d8674bcea14a55d867d/messages", TotalCount:102},
           Status:          "active",
           CreatedDatetime: time.Time{
               wall: 0x0,
               ext:  63718844388,
               loc:  (*time.Location)(nil),
           },
           UpdatedDatetime: &time.Time{
               wall: 0xc5d1c3d,
               ext:  63719019083,
               loc:  (*time.Location)(nil),
           },
           LastReceivedDatetime: &time.Time{
               wall: 0xbfa5359,
               ext:  63719019083,
               loc:  (*time.Location)(nil),
           },
       },
   },
}`,
  python: `items IDs  : ['c92c0babdc764d8674bcea14a55d867d', 'ef39fbf69170b58787ce4e574db9d842']
offset     : 0
limit      : 10
count      : 2
totalCount : 2`,
  java: `ListBase{offset=0, limit=10, totalCount=2, links=null, items=[Conversation{id='244673d844934e1a8d31eeb0a3a07d11', contactId='1e8f5a1b8d8ee144803691273c2670a2', contact=ConversationContact{id='1e8f3a1b8d8e4e44603691273c2670a2', href='https://contacts.messagebird.com/v2/contacts/1e8f5a1b8d8ee144803691273c2670a2', msisdn='null', firstName='Example', lastName='Customer', customDetails={}, createdDatetime=Tue Mar 03 15:59:49 CET 2020, updatedDatetime=Tue Mar 03 15:59:50 CET 2020}, channels=[ConversationChannel{id='16bb8e90ae884914bdb883326cce029e', name='MessageBird Test', status=active, platformId='sms', createdDatetime=Tue Mar 03 14:46:33 CET 2020, updatedDatetime=Tue Mar 03 15:58:19 CET 2020}], messages=MessageReference{href='https://conversations.messagebird.com/v1/conversations/744673d854934e1a8d31eeb0a3a07d15/messages', totalCount=2}, status=active, createdDatetime=Tue Mar 03 15:59:48 CET 2020, updatedDatetime=Mon Mar 09 16:47:02 CET 2020, lastReceivedDatetime=Mon Mar 09 16:47:02 CET 2020, lastUsedChannelId='26b38e90a4884914bdb883326cce029e'}, Conversation{id='133fc4d51a4049a699d1ea622b31858a', contactId='1b50545e0bb8488f8195c2d910302089', contact=ConversationContact{id='1b50535e0bb8480f8195c2d910302039', href='https://contacts.messagebird.com/v2/contacts/1b50535e0bb8480f8195c2d910302039', msisdn='null', firstName='', lastName='', customDetails={}, createdDatetime=Tue Mar 03 16:00:24 CET 2020, updatedDatetime=Tue Mar 03 16:00:24 CET 2020}, channels=[ConversationChannel{id='36bb4e90ae884914bdb883326cce029e', name='MessageBird', status=active, createdDatetime=Tue Mar 03 14:46:33 CET 2020, updatedDatetime=Tue Mar 03 15:58:19 CET 2020}], messages=MessageReference{href='https://conversations.messagebird.com/v1/conversations/83cf29d51a4049a699d1ea62b131858a/messages', totalCount=1}, status=active, createdDatetime=Tue Mar 03 16:00:24 CET 2020, updatedDatetime=Tue Mar 03 16:00:26 CET 2020, lastReceivedDatetime=Tue Mar 03 16:00:25 CET 2020, lastUsedChannelId='18bb2e90ae88491dbdb883326cce129e',lastUsedPlatformId='sms'}]}`,
};

export const GET_CONVERSATION_ENDPOINT = {
  bash: `GET /v1/conversations/{id}`,
};

export const GET_CONVERSATION_REQUEST_EXAMPLE = {
  curl: `curl -X GET "https://conversations.messagebird.com/v1/conversations/2e15efafec384e1c82e9842075e87beb" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM"`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

messagebird.conversations.read('2e15efafec384e1c82e9842075e87beb', function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
  php: `<?php
require './vendor/messagebird/php-rest-api/autoload.php';

$MessageBird = new \MessageBird\Client('YOUR_ACCESS_KEY');

$conversation_id = "c92c0babdc764d8674bcea14a55d867d";

$conversation = $MessageBird->conversations->read($conversation_id);
print_r($conversation);`,
  csharp: `using System;
using MessageBird;
using MessageBird.Exceptions;
using MessageBird.Net.ProxyConfigurationInjector;
using MessageBird.Objects;
using Newtonsoft.Json;

namespace Examples
{
    class GetConversation
    {
        const string YourAccessKey = "YOUR_ACCESS_KEY";
        const string ConversationId = "377ea40868d8d2c96ddec46e58224062";

        static void Main(string[] args)
        {
            IProxyConfigurationInjector proxyConfigurationInjector = null;

            Client client = Client.CreateDefault(YourAccessKey, proxyConfigurationInjector);

            try
            {
                MessageBird.Objects.Conversations.Conversation conversation = client.ViewConversation(ConversationId);

                var jsonString = JsonConvert.SerializeObject(
                        conversation, Formatting.Indented,
                        new JsonConverter[] {});
                Console.WriteLine(jsonString);
            }
            catch (ErrorException e)
            {
                // Either the request fails with error descriptions from the endpoint.
                if (e.HasErrors)
                {
                    foreach (Error error in e.Errors)
                    {
                        Console.WriteLine("code: {0} description: '{1}' parameter: '{2}'", error.Code, error.Description, error.Parameter);
                    }
                }
                // or fails without error information from the endpoint, in which case the reason contains a 'best effort' description.
                if (e.HasReason)
                {
                    Console.WriteLine(e.Reason);
                }

        }
    }
}`,
  ruby: `require 'pp'
require 'messagebird'

client = MessageBird::Client.new('YOUR_ACCESS_KEY')

conversation_id = '377ea40868d8d2c96ddec46e58224062'

conversation = client.conversation(conversation_id)
pp conversation`,
  go: `client := messagebird.New("YOUR_ACCESS_KEY")

conversationID := "377ea40868d8d2c96ddec46e58224062"

conv, err := conversation.Read(client, conversationID)
if err != nil {
    fmt.Println(err)
    return
}

fmt.Println(conv)`,
  python: `import messagebird

client = messagebird.Client('YOUR_ACCESS_KEY')

conversation_id = '377ea40868d8d2c96ddec46e58224062'

conversations = client.conversation_read(conversation_id)
print(conversations.__str__())`,
  java: `import com.messagebird.MessageBirdClient;
import com.messagebird.MessageBirdService;
import com.messagebird.MessageBirdServiceImpl;
import com.messagebird.exceptions.GeneralException;
import com.messagebird.exceptions.NotFoundException;
import com.messagebird.exceptions.UnauthorizedException;
import com.messagebird.objects.conversations.*;

public class GetConversation {
    private static final String AccessKey = "YOUR_ACCESS_KEY";
    private static final String ConversationID = "377ea40868d8d2c96ddec46e58224062";

    public static void main(String[] args) {
        final MessageBirdService wsr = new MessageBirdServiceImpl(AccessKey);
        final MessageBirdClient messageBirdClient = new MessageBirdClient(wsr);

        try {
            Conversation conversation = messageBirdClient.viewConversation(ConversationID);
            System.out.println(conversation);
        } catch (GeneralException | UnauthorizedException | NotFoundException exception) {
            exception.printStackTrace();
        }
    }
}`,
};

export const GET_CONVERSATION_RESPONSE_EXAMPLE = {
  json: `{
  "id": "2e15efafec384e1c82e9842075e87beb",
  "contactId": "a621095fa44947a28b441cfdf85cb802",
  "contact": {
  "id": "a621095fa44947a28b441cfdf85cb802",
  "href": "https://rest.messagebird.com/1/contacts/a621095fa44947a28b441cfdf85cb802",
  "msisdn": 316123456789,
  "firstName": "Jen",
  "lastName": "Smith",
  "customDetails": {
    "custom1": null,
    "custom2": null,
    "custom3": null,
    "custom4": null
  },
  "createdDatetime": "2018-06-03T20:06:03Z",
  "updatedDatetime": null
  },
  "channels": [
  {
    "id": "853eeb5348e541a595da93b48c61a1ae",
    "name": "SMS",
    "platformId": "sms",
    "status": "active",
    "createdDatetime": "2018-08-28T11:56:57Z",
    "updatedDatetime": "2018-08-29T08:16:33Z"
  },
  {
    "id": "619747f69cf940a98fb443140ce9aed2",
    "name": "My WhatsApp",
    "platformId": "whatsapp",
    "status": "active",
    "createdDatetime": "2018-08-28T11:56:57Z",
    "updatedDatetime": "2018-08-29T08:16:33Z"
  }
  ],
  "status": "active",
  "createdDatetime": "2018-08-13T09:17:22Z",
  "updatedDatetime": "2018-08-29T07:35:48Z",
  "lastReceivedDatetime": "2018-08-29T07:35:48Z",
  "lastUsedChannelId": "853eeb5348e541a595da93b48c61a1ae",
  "lastUsedPlatformId": "sms",
  "messages": {
  "totalCount": 23,
  "href": "https://conversations.messagebird.com/v1/conversations/2e15efafec384e1c82e9842075e87beb/messages"
  }
}`,
  php: `MessageBird\Objects\Conversation\Conversation Object
(
    [id] => c92c0babdc764d8674bcea14a55d867d
    [href] =>
    [contact] => MessageBird\Objects\Conversation\Contact Object
        (
            [id] => ef39fbf69170b58787ce4e574db9d842
            [href] => https://contacts.messagebird.com/v2/contacts/9e8f5a1b8d8e4e44803691273c2670a2
            [msisdn] =>
            [firstName] => Example
            [lastName] => Customer
            [customDetails] => Array
                (
                )

            [createdDatetime] => 2020-03-03T14:59:49Z
            [updatedDatetime] => 2020-03-03T14:59:50Z
        )

    [channels] => Array
        (
            [0] => MessageBird\Objects\Conversation\Channel Object
                (
                    [id] => 3ab1faad513e753501264a716622ba06
                    [name] => MessageBird Test
                    [platformId] => telegram
                    [status] => active
                    [createdDatetime] => 2020-03-03T13:46:33Z
                    [updatedDatetime] => 2020-03-03T14:58:19Z
                )

        )

    [status] => active
    [messages] => MessageBird\Objects\Conversation\MessageReference Object
        (
            [href] => https://conversations.messagebird.com/v1/conversations/377ea40868d8d2c96ddec46e58224062/messages
            [totalCount] => 102
        )

    [lastUsedChannelId] => 3ab1faad513e753501264a716622ba06
    [lastUsedPlatformId] => telegram
    [lastReceivedDatetime] => 2020-03-05T15:31:23.200954713Z
    [createdDatetime] => 2020-03-03T14:59:48Z
    [updatedDatetime] => 2020-03-05T15:31:23.207428669Z
)`,
  csharp: `{
  "id": "377ea40868d8d2c96ddec46e58224062",
  "contactId": "522eb1b675008b50a623358bb6056de7",
  "contact": {
    "id": "522eb1b675008b50a623358bb6056de7",
    "href": "https://contacts.messagebird.com/v2/contacts/522eb1b675008b50a623358bb6056de7",
    "msisdn": null,
    "firstName": "Example",
    "lastName": "Customer",
    "customDetails": {},
    "createdDatetime": "2020-03-03T14:59:49Z",
    "updatedDatetime": "2020-03-03T14:59:50Z"
  },
  "channels": [
    {
      "id": "80034edc86859cc28c24621cba83c919",
      "name": "MessageBird Test",
      "platformId": "telegram",
      "status": "active",
      "createdDatetime": "2020-03-03T13:46:33Z",
      "updatedDatetime": "2020-03-03T14:58:19Z"
    }
  ],
  "messages": {
    "href": "https://conversations.messagebird.com/v1/conversations/377ea40868d8d2c96ddec46e58224062/messages",
    "totalCount": 102
  },
  "status": "active",
  "createdDatetime": "2020-03-03T14:59:48Z",
  "updatedDatetime": "2020-03-05T15:31:23.2074287Z",
  "lastReceivedDatetime": "2020-03-05T15:31:23.2009547Z",
  "lastUsedChannelId": "80034edc86859cc28c24621cba83c919",
  "lastUsedPlatformId": "telegram"
}`,
  ruby: `#<MessageBird::Conversation:0x0000377ea40868d8
 @channels=
  [#<MessageBird::ConversationChannel:0x0000377ea40868d8
    @createdDatetime=2020-03-03 13:46:33 UTC,
    @id="80034edc86859cc28c24621cba83c919",
    @name="MessageBird Test",
    @platformId="telegram",
    @status="active",
    @updatedDatetime=2020-03-03 14:58:19 UTC>],
 @contact=
  #<MessageBird::Contact:0x0000377ea40868d8
   @createdDatetime=2020-03-03 14:59:49 UTC,
   @customDetails=#<MessageBird::CustomDetails:0x0000377ea40868d8>,
   @firstName="Example",
   @href=
    "https://contacts.messagebird.com/v2/contacts/c92c0babdc764d8674bcea14a55d867d",
   @id="c92c0babdc764d8674bcea14a55d867d",
   @lastName="Customer",
   @msisdn=nil,
   @updatedDatetime=2020-03-03 14:59:50 UTC>,
 @contactId="c92c0babdc764d8674bcea14a55d867d",
 @createdDatetime=2020-03-03 14:59:48 UTC,
 @id="377ea40868d8d2c96ddec46e58224062",
 @lastReceivedDatetime=2020-03-06 12:36:01 UTC,
 @lastUsedChannelId="80034edc86859cc28c24621cba83c919",
 @lastUsedPlatformId="telegram",
 @messages=
  #<MessageBird::MessageReference:0x0000377ea40868
   @href=
    "https://conversations.messagebird.com/v1/conversations/377ea40868d8d2c96ddec46e58224062/messages",
   @totalCount=103>,
 @status="active",
 @updatedDatetime=2020-03-06 12:36:01 UTC>`,
  go: `&conversation.Conversation{
   ID:        "377ea40868d8d2c96ddec46e58224062",
   ContactID: "effad32703fc27a3b51dc40172e64723",
   Contact:   &conversation.Contact{
       ID:            "effad32703fc27a3b51dc40172e64723",
       Href:          "https://contacts.messagebird.com/v2/contacts/effad32703fc27a3b51dc40172e64723",
       MSISDN:        "",
       FirstName:     "Example",
       LastName:      "Customer",
       CustomDetails: {
       },
       CreatedAt: (*time.Time)(nil),
       UpdatedAt: (*time.Time)(nil),
   },
   LastUsedChannelID: "c92c0babdc764d8674bcea14a55d867d",
   LastUsedPlatformID: "telegram",
   Channels:          {
       &conversation.Channel{
           ID:              "c92c0babdc764d8674bcea14a55d867d",
           Name:            "MessageBird Test",
           PlatformID:      "telegram",
           Status:          "active",
           CreatedDatetime: &time.Time{
               wall: 0x0,
               ext:  63718839993,
               loc:  (*time.Location)(nil),
           },
           UpdatedDatetime: &time.Time{
               wall: 0x0,
               ext:  63718844299,
               loc:  (*time.Location)(nil),
           },
       },
   },
   Messages:        &conversation.MessagesCount{HRef:"https://conversations.messagebird.com/v1/conversations/377ea40868d8d2c96ddec46e58224062/messages", TotalCount:103},
   Status:          "active",
   CreatedDatetime: time.Time{
       wall: 0x0,
       ext:  63718844388,
       loc:  (*time.Location)(nil),
   },
   UpdatedDatetime: &time.Time{
       wall: 0x182c224b,
       ext:  63719094961,
       loc:  (*time.Location)(nil),
   },
   LastReceivedDatetime: &time.Time{
       wall: 0x17dd94c4,
       ext:  63719094961,
       loc:  (*time.Location)(nil),
   },
}`,
  python: `id                   : 377ea40868d8d2c96ddec46e58224062
contact id           : c92c0babdc764d8674bcea14a55d867d
last used channel id : ef39fbf69170b58787ce4e574db9d842
message total count  : 103
status               : active
created date time    : 2020-03-03 14:59:48+00:00
updated date time    : 2020-03-06 12:36:01+00:00
last received date   : 2020-03-06 12:36:01+00:00`,
  java: `Conversation{id='377ea40868d8d2c96ddec46e58224062', contactId='1c8f5a2b8d8e7e44803691271c2673a2', contact=ConversationContact{id='1c8f5a2b8d8e7e44803691271c2673a2', href='https://contacts.messagebird.com/v2/contacts/1c8f5a2b8d8e7e44803691271c2673a2', msisdn='null', firstName='Example', lastName='Customer', customDetails={}, createdDatetime=Tue Mar 03 15:59:49 CET 2020, updatedDatetime=Tue Mar 03 15:59:50 CET 2020}, channels=[ConversationChannel{id='a3bb8e90ae884914bdb883326cce0290', name='MessageBird', status=active, createdDatetime=Tue Mar 03 14:46:33 CET 2020, updatedDatetime=Tue Mar 03 15:58:19 CET 2020}], messages=MessageReference{href='https://conversations.messagebird.com/v1/conversations/377ea40868d8d2c96ddec46e58224062/messages', totalCount=109}, status=active, createdDatetime=Tue Mar 03 15:59:48 CET 2020, updatedDatetime=Mon Mar 09 16:47:02 CET 2020, lastReceivedDatetime=Mon Mar 09 16:47:02 CET 2020, lastUsedChannelId='c92c0babdc764d8674bcea14a55d867d', lastUsedPlatformId='sms'}`,
};

export const UPDATE_CONVERSATION_ENDPOINT = {
  bash: `PATCH /v1/conversations/{id}`,
};

export const UPDATE_CONVERSATION_REQUEST_EXAMPLE = {
  curl: `curl -X PATCH "https://conversations.messagebird.com/v1/conversations/2e15efafec384e1c82e9842075e87beb" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "status": "archived"
  }'`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

var params = {
  'status': 'archived'
};

messagebird.conversations.update('2e15efafec384e1c82e9842075e87beb', params, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
};

export const UPDATE_CONVERSATION_RESPONSE_EXAMPLE = {
  json: `{
  "id": "2e15efafec384e1c82e9842075e87beb",
  "contactId": "a621095fa44947a28b441cfdf85cb802",
  "contact": {
  "id": "a621095fa44947a28b441cfdf85cb802",
  "href": "https://rest.messagebird.com/1/contacts/a621095fa44947a28b441cfdf85cb802",
  "msisdn": 316123456789,
  "firstName": "Jen",
  "lastName": "Smith",
  "customDetails": {
    "custom1": null,
    "custom2": null,
    "custom3": null,
    "custom4": null
  },
  "createdDatetime": "2018-06-03T20:06:03Z",
  "updatedDatetime": null
  },
  "channels": [
  {
    "id": "853eeb5348e541a595da93b48c61a1ae",
    "name": "SMS",
    "platformId": "sms",
    "status": "active",
    "createdDatetime": "2018-08-28T11:56:57Z",
    "updatedDatetime": "2018-08-29T08:16:33Z"
  },
  {
    "id": "619747f69cf940a98fb443140ce9aed2",
    "name": "My WhatsApp",
    "platformId": "whatsapp",
    "status": "active",
    "createdDatetime": "2018-08-28T11:56:57Z",
    "updatedDatetime": "2018-08-29T08:16:33Z"
  }
  ],
  "status": "archived",
  "createdDatetime": "2018-08-13T09:17:22Z",
  "updatedDatetime": "2018-08-29T07:35:48Z",
  "lastReceivedDatetime": "2018-08-29T07:35:48Z",
  "lastUsedChannelId": "853eeb5348e541a595da93b48c61a1ae",
  "lastUsedPlatformId": "sms",
  "messages": {
  "totalCount": 23,
  "href": "https://conversations.messagebird.com/v1/conversations/2e15efafec384e1c82e9842075e87beb/messages"
  }
}`,
};

export const REPLY_TO_CONVERSATION_ENDPOINT = {
  bash: `POST /v1/conversations/{conversation_id}/messages`,
};

export const REPLY_TO_CONVERSATION_REQUEST_EXAMPLE = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/conversations/2e15efafec384e1c82e9842075e87beb/messages" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
  "type": "text",
  "content": {
    "text": "Hello!"},
    "source": {"foo":"var"}
  }'`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

var params = {
  'type': 'text',
  'content': {
  'text': 'Hello!'
  },
  "source": {
    "foo":"var"
  }
}

messagebird.conversations.reply('2e15efafec384e1c82e9842075e87beb', params, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
};

export const REPLY_TO_CONVERSATION_RESPONSE_EXAMPLE = {
  json: `{
  "id": "13a97a5023944648b8e5e61248c40da8",
  "conversationId": "2e15efafec384e1c82e9842075e87beb",
  "channelId": "a621095fa44947a28b441cfdf85cb802",
  "status": "pending",
  "to":"+31612345678",
  "from":"+31687654321",
  "type": "text",
  "direction": "sent",
  "content": {
    "text": "This is a test message"
  },
  "createdDatetime": "2018-08-29T13:53:44.642664784Z",
  "updatedDatetime": "2018-08-29T13:53:44.673850825Z",
  "source": {
    "foo": "bar"
  }
}`,
};

export const GET_MESSAGES_IN_CONVERSATION_ENDPOINT = {
  bash: `GET /v1/conversations/{id}/messages`,
};

export const GET_MESSAGE_ENDPOINT = {
  bash: `GET /v1/messages/{id}`,
};

export const GET_MESSAGES_ENDPOINT = {
  bash: `GET /v1/messages?ids={ids}&from={datetime}`,
};

export const GET_MESSAGES_IN_CONVERSATION_REQUEST_EXAMPLE = {
  curl: `curl -X GET "https://conversations.messagebird.com/v1/conversations/5f3437fdb8444583aea093a047ac014b/messages" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM"`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

const conversationId = '5f3437fdb8444583aea093a047ac014b';

messagebird.conversations.listMessages(conversationId, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
  go: `client := messagebird.New("YOUR_ACCESS_KEY")

conversationID := "5f3437fdb8444583aea093a047ac014b"

messages, err := conversation.ListMessages(client, conversationID, nil)
if err != nil {
    fmt.Println(err)
    return
}

fmt.Println(messages)`,
  python: `import messagebird

client = messagebird.Client('YOUR_ACCESS_KEY')

conversation_id = '5f3437fdb8444583aea093a047ac014b'

messages = client.conversation_list_messages(conversation_id)
print(messages.__str__())`,
  php: `<?php
require './vendor/messagebird/php-rest-api/autoload.php';

$MessageBird = new \MessageBird\Client('YOUR_API_KEY');

$conversation_id = '5f3437fdb8444583aea093a047ac014b';

$messages = $MessageBird->conversationMessages->getList($conversation_id);

print_r($messages);`,
  csharp: `using System;
using MessageBird;
using MessageBird.Exceptions;
using MessageBird.Net.ProxyConfigurationInjector;
using MessageBird.Objects;
using Newtonsoft.Json;

namespace Examples
{
    class ListConversationMessages
    {
        const string YourAccessKey = "YOUR_ACCESS_KEY";
        const string ConversationId = "5f3437fdb8444583aea093a047ac014b";

        static void Main(string[] args)
        {
            IProxyConfigurationInjector proxyConfigurationInjector = null;

            Client client = Client.CreateDefault(YourAccessKey, proxyConfigurationInjector);

            try
            {
                MessageBird.Objects.Conversations.ConversationMessageList messages = client.ListConversationMessages(ConversationId);

                var jsonString = JsonConvert.SerializeObject(
                        messages, Formatting.Indented,
                        new JsonConverter[] {});
                Console.WriteLine(jsonString);
            }
            catch (ErrorException e)
            {
                // Either the request fails with error descriptions from the endpoint.
                if (e.HasErrors)
                {
                    foreach (Error error in e.Errors)
                    {
                        Console.WriteLine("code: {0} description: '{1}' parameter: '{2}'", error.Code, error.Description, error.Parameter);
                    }
                }
                // or fails without error information from the endpoint, in which case the reason contains a 'best effort' description.
                if (e.HasReason)
                {
                    Console.WriteLine(e.Reason);
                }
            }
        }
    }
}`,
  ruby: `require 'pp'
require 'messagebird'

client = MessageBird::Client.new('YOUR_ACCESS_KEY')

conversation_id = '5f3437fdb8444583aea093a047ac014b'

messages = client.conversation_messages_list(conversation_id)

pp messages`,
  java: `import com.messagebird.MessageBirdClient;
import com.messagebird.MessageBirdService;
import com.messagebird.MessageBirdServiceImpl;
import com.messagebird.exceptions.GeneralException;
import com.messagebird.exceptions.UnauthorizedException;
import com.messagebird.objects.conversations.*;

public class ListMessages {
    private static final String AccessKey = "YOUR_ACCESS_KEY";
    private static final String ConversationID = "5f3437fdb8444583aea093a047ac014b";

    public static void main(String[] args) {
        final MessageBirdService wsr = new MessageBirdServiceImpl(AccessKey);
        final MessageBirdClient messageBirdClient = new MessageBirdClient(wsr);

        try {
            ConversationMessageList messages = messageBirdClient.listConversationMessages(ConversationID);
            System.out.println(messages);
        } catch (GeneralException | UnauthorizedException exception) {
            exception.printStackTrace();
        }
    }
}`,
};

export const GET_MESSAGES_IN_CONVERSATION_RESPONSE_EXAMPLE = {
  json: `{
  "count": 2,
  "items": [
    {
      "id": "a25c8e4dbd0347198c6c404a6db2aadc",
      "conversationId": "5f3437fdb8444583aea093a047ac014b",
      "platform": "telegram",
      "to": "517420321",
      "from": "MessageBird",
      "channelId": "c92c0babdc764d8674bcea14a55d867d",
      "type": "text",
      "content": {
        "text": "Hello!"
      },
      "direction": "sent",
      "status": "sent",
      "createdDatetime": "2020-03-06T12:35:59.957903187Z",
      "updatedDatetime": "2020-03-06T12:36:01.405545547Z"
    },
    {
      "id": "195d2ac7ea364564a54ed5f9b05c4c17",
      "conversationId": "5f3437fdb8444583aea093a047ac014b",
      "platform": "telegram",
      "to": "121830327",
      "from": "MessageBird",
      "channelId": "c92c0babdc764d8674bcea14a55d867d",
      "type": "text",
      "content": {
        "text": "Hello!"
      },
      "direction": "sent",
      "status": "sent",
      "createdDatetime": "2020-03-05T15:31:23.200954713Z",
      "updatedDatetime": "2020-03-05T15:31:23.207428669Z"
    }
  ],
  "limit": 10,
  "offset": 0,
  "totalCount": 2
}`,
  go: `conversation.MessageList{
   Offset:     0,
   Limit:      10,
   Count:      2,
   TotalCount: 2,
   Items:      {
       &conversation.Message{
           ID:             "a25c8e4dbd0347198c6c404a6db2aadc",
           ConversationID: "5f3437fdb8444583aea093a047ac014b",
           ChannelID:      "c92c0babdc764d8674bcea14a55d867d",
           Direction:      "sent",
           Status:         "sent",
           Type:           "text",
           Content:        conversation.MessageContent{
               Audio:    (*conversation.Audio)(nil),
               File:     (*conversation.File)(nil),
               Image:    (*conversation.Image)(nil),
               Location: (*conversation.Location)(nil),
               Video:    (*conversation.Video)(nil),
               Text:     "Hello!",
               HSM:      (*conversation.HSM)(nil),
           },
           CreatedDatetime: &time.Time{
               wall: 0x39187153,
               ext:  63719094959,
               loc:  (*time.Location)(nil),
           },
           UpdatedDatetime: &time.Time{
               wall: 0x182c224b,
               ext:  63719094961,
               loc:  (*time.Location)(nil),
           },
       },
       &conversation.Message{
           ID:             "195d2ac7ea364564a54ed5f9b05c4c17",
           ConversationID: "5f3437fdb8444583aea093a047ac014b",
           ChannelID:      "c92c0babdc764d8674bcea14a55d867d",
           Direction:      "sent",
           Status:         "sent",
           Type:           "text",
           Content:        conversation.MessageContent{
               Audio:    (*conversation.Audio)(nil),
               File:     (*conversation.File)(nil),
               Image:    (*conversation.Image)(nil),
               Location: (*conversation.Location)(nil),
               Video:    (*conversation.Video)(nil),
               Text:     "Hello!",
               HSM:      (*conversation.HSM)(nil),
           },
           CreatedDatetime: &time.Time{
               wall: 0xbfa5359,
               ext:  63719019083,
               loc:  (*time.Location)(nil),
           },
           UpdatedDatetime: &time.Time{
               wall: 0xc5d1c3d,
               ext:  63719019083,
               loc:  (*time.Location)(nil),
           },
       },
   },
}`,
  python: `items IDs  : ['a25c8e4dbd0347198c6c404a6db2aadc', '195d2ac7ea364564a54ed5f9b05c4c17']
offset     : 0
limit      : 10
count      : 2
totalCount : 2`,
  php: `MessageBird\Objects\BaseList Object
(
    [limit] => 10
    [offset] => 0
    [count] => 2
    [totalCount] => 2
    [links] => Array
        (
            [first] =>
            [previous] =>
            [next] =>
            [last] =>
        )

    [items] => Array
        (
            [0] => MessageBird\Objects\Conversation\Message Object
                (
                    [id] => a25c8e4dbd0347198c6c404a6db2aadc
                    [conversationId] => 5f3437fdb8444583aea093a047ac014b
                    [channelId] => c92c0babdc764d8674bcea14a55d867d
                    [direction] => sent
                    [status] => sent
                    [type] => text
                    [content] => MessageBird\Objects\Conversation\Content Object
                        (
                            [audio] =>
                            [file] =>
                            [image] =>
                            [location] =>
                            [text] => Hello!
                            [video] =>
                            [hsm] =>
                        )

                    [to] => 121830327
                    [createdDatetime] => 2020-03-06T12:35:59.957903187Z
                    [updatedDatetime] => 2020-03-06T12:36:01.405545547Z
                )

            [1] => MessageBird\Objects\Conversation\Message Object
                (
                    [id] => 195d2ac7ea364564a54ed5f9b05c4c17
                    [conversationId] => 5f3437fdb8444583aea093a047ac014b
                    [channelId] => c92c0babdc764d8674bcea14a55d867d
                    [direction] => sent
                    [status] => sent
                    [type] => text
                    [content] => MessageBird\Objects\Conversation\Content Object
                        (
                            [audio] =>
                            [file] =>
                            [image] =>
                            [location] =>
                            [text] => Hello!
                            [video] =>
                            [hsm] =>
                        )

                    [to] => 121830327
                    [createdDatetime] => 2020-03-05T15:31:23.200954713Z
                    [updatedDatetime] => 2020-03-05T15:31:23.207428669Z
                )

        )

)`,
  csharp: `{
  "ConversationId": "5f3437fdb8444583aea093a047ac014b",
  "limit": 10,
  "offset": 0,
  "count": 2,
  "totalCount": 2,
  "links": null,
  "items": [
    {
      "id": "a25c8e4dbd0347198c6c404a6db2aadc",
      "conversationId": "5f3437fdb8444583aea093a047ac014b",
      "channelId": "c92c0babdc764d8674bcea14a55d867d",
      "direction": "sent",
      "status": "sent",
      "type": "text",
      "content": {
        "audio": null,
        "file": null,
        "hsm": null,
        "image": null,
        "location": null,
        "text": "Hello!",
        "video": null
      },
      "error": null,
      "createdDatetime": "2020-03-06T12:35:59.9579032Z",
      "updatedDatetime": "2020-03-06T12:36:01.4055455Z"
    },
    {
      "id": "195d2ac7ea364564a54ed5f9b05c4c17",
      "conversationId": "5f3437fdb8444583aea093a047ac014b",
      "channelId": "c92c0babdc764d8674bcea14a55d867d",
      "direction": "sent",
      "status": "sent",
      "type": "text",
      "content": {
        "audio": null,
        "file": null,
        "hsm": null,
        "image": null,
        "location": null,
        "text": "Hello!",
        "video": null
      },
      "error": null,
      "createdDatetime": "2020-03-05T15:31:23.2009547Z",
      "updatedDatetime": "2020-03-05T15:31:23.2074287Z"
    }
  ],
  "Id": ""
}`,
  ruby: `#<List:0x00007f9e3010f880
 @count=2,
 @items=
  [#<MessageBird::ConversationMessage:0x0000af1e33102710
    @channelId="c92c0babdc764d8674bcea14a55d867d",
    @content={"text"=>"Hello!"},
    @conversationId="5f3437fdb8444583aea093a047ac014b",
    @createdDatetime="2020-03-06T12:35:59.957903187Z",
    @direction="sent",
    @id="a25c8e4dbd0347198c6c404a6db2aadc",
    @status="sent",
    @type="text",
    @updatedDatetime="2020-03-06T12:36:01.405545547Z">,
   #<MessageBird::ConversationMessage:0x000013fe3011f1fa
    @channelId="c92c0babdc764d8674bcea14a55d867d",
    @content={"text"=>"Hello!"},
    @conversationId="5f3437fdb8444583aea093a047ac014b",
    @createdDatetime="2020-03-05T15:31:23.200954713Z",
    @direction="sent",
    @id="195d2ac7ea364564a54ed5f9b05c4c17",
    @status="sent",
    @type="text",
    @updatedDatetime="2020-03-05T15:31:23.207428669Z">],
 @limit=2,
 @offset=0,
 @totalCount=2,
 @type=MessageBird::ConversationMessage>`,
  java: `ListBase{offset=0, limit=10, totalCount=2, links=null, items=[ConversationMessage{id='c92c0babdc764d8674bcea14a55d867d', conversationId='ef39fbf69170b58787ce4e574db9d842', channelId='3ab1faad513e753501264a716622ba06', direction=sent, status=sent, type=text, content=ConversationContent{audio=null, file=null, hsm=null, image=null, location=null, text='Hello!', video=null}, createdDatetime=Mon Mar 09 16:47:01 CET 2020, updatedDatetime=Mon Mar 09 16:47:02 CET 2020}, ConversationMessage{id='45992a02f948fe230c3265ae8175b91b', conversationId='ef39fbf69170b58787ce4e574db9d842', channelId='3ab1faad513e753501264a716622ba06, direction=sent, status=sent, type=text, content=ConversationContent{audio=null, file=null, hsm=null, image=null, location=null, text='Hello!', video=null}, createdDatetime=Mon Mar 09 16:46:45 CET 2020, updatedDatetime=Mon Mar 09 16:46:46 CET 2020}]}`,
};

export const GET_MESSAGE_REQUEST_EXAMPLE = {
  curl: `curl -X GET "https://conversations.messagebird.com/v1/messages/5f3437fdb8444583aea093a047ac014b" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM"`,
  go: `client := messagebird.New("YOUR_ACCESS_KEY")

messageID := "5f3437fdb8444583aea093a047ac014b"

message, err := conversation.ReadMessage(client, messageID)
if err != nil {
    fmt.Println(err)
    return
}

fmt.Println(message)`,
  ruby: `require 'pp'
require 'messagebird'

client = MessageBird::Client.new('YOUR_ACCESS_KEY')

message_id = '5f3437fdb8444583aea093a047ac014b'

msg = client.conversation_message(message_id)
pp msg`,
  python: `import messagebird

client = messagebird.Client('YOUR_ACCESS_KEY')

message_id = "5f3437fdb8444583aea093a047ac014b"

message = client.conversation_read_message(message_id)
print(message.__str__())`,
  php: `<?php
require './vendor/messagebird/php-rest-api/autoload.php';

$MessageBird = new \MessageBird\Client('YOUR_API_KEY');

$message_id = '5f3437fdb8444583aea093a047ac014b';

$message = $MessageBird->messages->read();

print_r($message);`,
  csharp: `using System;
using MessageBird;
using MessageBird.Exceptions;
using MessageBird.Net.ProxyConfigurationInjector;
using MessageBird.Objects;
using Newtonsoft.Json;

namespace Examples
{
    class GetConversation
    {
        const string YourAccessKey = "YOUR_ACCESS_KEY";
        const string MessageId = "5f3437fdb8444583aea093a047ac014b";

        static void Main(string[] args)
        {
            IProxyConfigurationInjector proxyConfigurationInjector = null;

            Client client = Client.CreateDefault(YourAccessKey, proxyConfigurationInjector);

            try
            {
                MessageBird.Objects.Conversations.ConversationMessage message = client.ViewConversationMessage(MessageId);

                var jsonString = JsonConvert.SerializeObject(
                        message, Formatting.Indented,
                        new JsonConverter[] {});
                Console.WriteLine(jsonString);
            }
            catch (ErrorException e)
            {
                // Either the request fails with error descriptions from the endpoint.
                if (e.HasErrors)
                {
                    foreach (Error error in e.Errors)
                    {
                        Console.WriteLine("code: {0} description: '{1}' parameter: '{2}'", error.Code, error.Description, error.Parameter);
                    }
                }
                // or fails without error information from the endpoint, in which case the reason contains a 'best effort' description.
                if (e.HasReason)
                {
                    Console.WriteLine(e.Reason);
                }
            }
        }
    }
}`,
  java: `import com.messagebird.MessageBirdClient;
import com.messagebird.MessageBirdService;
import com.messagebird.MessageBirdServiceImpl;
import com.messagebird.exceptions.GeneralException;
import com.messagebird.exceptions.NotFoundException;
import com.messagebird.exceptions.UnauthorizedException;
import com.messagebird.objects.conversations.*;

public class GetMessage {
    private static final String AccessKey = "YOUR_ACCESS_KEY";
    private static final String MessageID = "5f3437fdb8444583aea093a047ac014b";

    public static void main(String[] args) {
        final MessageBirdService wsr = new MessageBirdServiceImpl(AccessKey);
        final MessageBirdClient messageBirdClient = new MessageBirdClient(wsr);

        try {
            ConversationMessage message = messageBirdClient.viewConversationMessage(MessageID);
            System.out.println(message);
        } catch (GeneralException | UnauthorizedException | NotFoundException exception) {
            exception.printStackTrace();
        }
    }
}`,
};

export const GET_MESSAGE_RESPONSE_EXAMPLE = {
  curl: `{
  "id": "5f3437fdb8444583aea093a047ac014b",
  "conversationId": "ef39fbf69170b58787ce4e574db9d842",
  "platform": "telegram",
  "to": "927241320",
  "from": "messagebird",
  "channelId": "3ab1faad513e753501264a716622ba06",
  "type": "text",
  "content": {
    "text": "Hello!"
  },
  "direction": "sent",
  "status": "sent",
  "createdDatetime": "2020-03-05T15:05:59.412358103Z",
  "updatedDatetime": "2020-03-05T15:05:59.418598938Z"
}`,
  go: `&conversation.Message{
   ID:             "5f3437fdb8444583aea093a047ac014b",
   ConversationID: "ef39fbf69170b58787ce4e574db9d842",
   ChannelID:      "3ab1faad513e753501264a716622ba06",
   Direction:      "sent",
   Status:         "sent",
   Type:           "text",
   Content:        conversation.MessageContent{
       Audio:    (*conversation.Audio)(nil),
       File:     (*conversation.File)(nil),
       Image:    (*conversation.Image)(nil),
       Location: (*conversation.Location)(nil),
       Video:    (*conversation.Video)(nil),
       Text:     "Hello!",
       HSM:      (*conversation.HSM)(nil),
   },
   CreatedDatetime: &time.Time{
       wall: 0x189415d7,
       ext:  63719017559,
       loc:  (*time.Location)(nil),
   },
   UpdatedDatetime: &time.Time{
       wall: 0x18f3501a,
       ext:  63719017559,
       loc:  (*time.Location)(nil),
   },
}`,
  ruby: `#<MessageBird::ConversationMessage:0x00001f832426cb68
 @channelId="3ab1faad513e753501264a716622ba06",
 @content={"text"=>"Hello!"},
 @conversationId="ef39fbf69170b58787ce4e574db9d842",
 @createdDatetime="2020-03-05T15:05:59.412358103Z",
 @direction="sent",
 @id="5f3437fdb8444583aea093a047ac014b",
 @status="sent",
 @type="text",
 @updatedDatetime="2020-03-05T15:05:59.418598938Z">`,
  python: `message id        : 5f3437fdb8444583aea093a047ac014b
channel id        : 3ab1faad513e753501264a716622ba06
direction         : sent
status            : sent
type              : text
content           : {'text': 'Hello!'}
created date time : 2020-03-05 15:05:59+00:00
updated date time : 2020-03-05 15:05:59+00:00`,
  php: `MessageBird\Objects\Message Object
(
    [id:protected] =>
    [href:protected] =>
    [direction] => mt
    [type] => sms
    [originator] =>
    [body] =>
    [reference] =>
    [validity] =>
    [gateway] =>
    [typeDetails] => Array
        (
        )

    [datacoding] => plain
    [mclass] => 1
    [scheduledDatetime] =>
    [createdDatetime:protected] =>
    [recipients] => Array
        (
        )

    [reportUrl] =>
)`,
  csharp: `{
  "id": "5f3437fdb8444583aea093a047ac014b",
  "conversationId": "ef39fbf69170b58787ce4e574db9d842",
  "channelId": "3ab1faad513e753501264a716622ba06",
  "direction": "sent",
  "status": "sent",
  "type": "text",
  "content": {
    "audio": null,
    "file": null,
    "hsm": null,
    "image": null,
    "location": null,
    "text": "Hello!",
    "video": null
  },
  "error": null,
  "createdDatetime": "2020-03-05T15:05:59.4123581Z",
  "updatedDatetime": "2020-03-05T15:05:59.4185989Z"
}`,
  java: `ConversationMessage{id='5f3437fdb8444583aea093a047ac014b', conversationId='ef39fbf69170b58787ce4e574db9d842', channelId='3ab1faad513e753501264a716622ba06', direction=sent, status=sent, type=text, content=ConversationContent{audio=null, file=null, hsm=null, image=null, location=null, text='Hello!', video=null}, createdDatetime=Thu Mar 05 16:05:59 CET 2020, updatedDatetime=Thu Mar 05 16:05:59 CET 2020}`,
};

export const GET_MESSAGES_REQUEST_EXAMPLE = {
  curl: `curl -X GET "https://conversations.messagebird.com/v1/messages?ids=5f3437fdb8444583aea093a047ac014b,4abc37fdb8444583aea093a047ac014c" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM"`,
};

export const GET_MESSAGES_RESPONSE_EXAMPLE = {
  curl: `{
  "items": [{
    "id": "5f3437fdb8444583aea093a047ac014b",
    "conversationId": "ef39fbf69170b58787ce4e574db9d842",
    "platform": "telegram",
    "to": "927241320",
    "from": "messagebird",
    "channelId": "3ab1faad513e753501264a716622ba06",
    "type": "text",
    "content": {
      "text": "Hello!"
    },
    "direction": "sent",
    "status": "sent",
    "createdDatetime": "2020-03-05T15:05:59.412358103Z",
    "updatedDatetime": "2020-03-05T15:05:59.418598938Z"
  }, {
    "id": "4abc37fdb8444583aea093a047ac014c",
    "conversationId": "ef39fbf69170b58787ce4e574db9d842",
    "platform": "telegram",
    "to": "927241320",
    "from": "messagebird",
    "channelId": "3ab1faad513e753501264a716622ba06",
    "type": "text",
    "content": {
      "text": "Hello 2!"
    },
    "direction": "sent",
    "status": "sent",
    "createdDatetime": "2020-03-05T15:05:59.412358103Z",
    "updatedDatetime": "2020-03-05T15:05:59.418598938Z"
  }]
}`,
};

export const CREATE_WEBHOOK_ENDPOINT = {
  bash: `POST /v1/webhooks`,
};

export const CREATE_WEBHOOK_REQUEST_EXAMPLE = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/webhooks/" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "events": ["message.created", "message.updated"],
    "channelId": "853eeb5348e541a595da93b48c61a1ae",
    "url": "https://example.com/webhook",
    "settings": {
       "expected_http_code" : "2xx",
       "headers": {
          "from" : "messagebird"
        },
       "query_params" : "transactionID=1312435365", 
       "username" : "user20121",
       "password" : "mypass1213",
       "retry": 2,
       "timeout": 14
    }
  }'`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

var params = {
  'events': [
  'message.created',
  'message.updated'
  ],
  'channelId': '853eeb5348e541a595da93b48c61a1ae',
  'url': 'https://example.com/webhook',
      'settings': {
        'expected_http_code' : '2xx',
        'headers': {
          'from' : 'messagebird'
        },
       'query_params' : 'transactionID=1312435365', 
       'username' : 'user20121',
       'password' : 'mypass1213',
       'retry': 2,
       'timeout': 14
    }
}

messagebird.conversations.webhooks.create(params, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
};

export const CREATE_WEBHOOK_RESPONSE_EXAMPLE = {
  json: `{
  "id": "985ae50937a94c64b392531ea87a0263",
  "url": "https://example.com/webhook",
  "channelId": "853eeb5348e541a595da93b48c61a1ae",
  "events": [
  "message.created",
  "message.updated",
  ],
  "status": "enabled",
  "createdDatetime": "2018-08-29T10:04:23Z",
  "updatedDatetime": null,
  "settings": {
       "expected_http_code" : "2xx",
       "headers": {
          "from" : "messagebird"
        },
       "query_params" : "transactionID=1312435365", 
       "username" : "user20121",
       "password" : "mypass1213",
       "retry": 2,
       "timeout": 14
    }
}`,
};

export const LIST_WEBHOOKS_ENDPOINT = {
  bash: `GET /v1/webhooks`,
};

export const LIST_WEBHOOKS_REQUEST_EXAMPLE = {
  curl: `curl -X GET "https://conversations.messagebird.com/v1/webhooks/" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM"`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

messagebird.conversations.webhooks.list(100, 0, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
};

export const LIST_WEBHOOKS_RESPONSE_EXAMPLE = {
  json: `{
  "offset": 0,
  "limit": 100,
  "count": 10,
  "totalCount": 10,
  "items": [
  {
    "id": "985ae50937a94c64b392531ea87a0263",
    "url": "https://example.com/webhook",
    "channelId": "853eeb5348e541a595da93b48c61a1ae",
    "events": [
    "message.created",
    "message.updated",
    ],
    "status": "enabled",
    "createdDatetime": "2018-08-29T10:04:23Z",
    "updatedDatetime": null,
    "settings": {
     }
  },
  // ... remaining webhooks omitted
  ]
}`,
};

export const GET_WEBHOOK_ENDPOINT = {
  bash: `GET /v1/webhooks/{id}`,
};

export const GET_WEBHOOK_REQUEST_EXAMPLE = {
  curl: `curl -X GET "https://conversations.messagebird.com/v1/webhooks/985ae50937a94c64b392531ea87a0263" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM"`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

messagebird.conversations.webhooks.read('985ae50937a94c64b392531ea87a0263', function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
};

export const GET_WEBHOOK_RESPONSE_EXAMPLE = {
  json: `{
  "id": "985ae50937a94c64b392531ea87a0263",
  "url": "https://example.com/webhook",
  "channelId": "853eeb5348e541a595da93b48c61a1ae",
  "events": [
  "message.created",
  "message.updated",
  ],
  "status": "enabled",
  "createdDatetime": "2018-08-29T10:04:23Z",
  "updatedDatetime": null,
  "settings": {
       "expected_http_code" : "2xx",
       "headers": {
          "from" : "messagebird"
        },
       "query_params" : "transactionID=1312435365", 
       "username" : "user20121",
       "password" : "mypass1213",
       "retry": 2,
       "timeout": 14
    }
}`,
};

export const UPDATE_WEBHOOK_ENDPOINT = {
  bash: `PATCH /v1/webhooks/{id}`,
};

export const UPDATE_WEBHOOK_REQUEST_EXAMPLE = {
  curl: `curl -X PATCH "https://conversations.messagebird.com/v1/webhooks/985ae50937a94c64b392531ea87a0263" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "status": "disabled",
    "settings": {
       "retry": 6,
       "timeout": 26
    }
  }'`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

var params = {
  'status': 'disabled',
  'settings': {
       'retry': 6,
       'timeout': 26
    }
}

messagebird.conversations.webhooks.update('985ae50937a94c64b392531ea87a0263', params, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
};

export const UPDATE_WEBHOOK_RESPONSE_EXAMPLE = {
  json: `{
  "id": "985ae50937a94c64b392531ea87a0263",
  "url": "https://example.com/webhook",
  "channelId": "853eeb5348e541a595da93b48c61a1ae",
  "events": [
  "message.created",
  "message.updated",
  ],
  "status": "disabled",
  "createdDatetime": "2018-08-29T10:04:23Z",
  "updatedDatetime": "2018-08-29T10:10:23Z",
  "settings": {
       "expected_http_code" : "2xx",
       "headers": {
          "from" : "messagebird"
        },
       "query_params" : "transactionID=1312435365", 
       "username" : "user20121",
       "password" : "mypass1213",
       "retry": 6,
       "timeout": 26
    }
}`,
};

export const DELETE_WEBHOOK_ENDPOINT = {
  bash: `DELETE https://conversations.messagebird.com/v1/webhooks/{id}`,
};

export const DELETE_WEBHOOK_REQUEST_EXAMPLE = {
  curl: `curl -X DELETE "https://conversations.messagebird.com/v1/webhooks/985ae50937a94c64b392531ea87a0263" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM"`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

messagebird.conversations.webhooks.delete('985ae50937a94c64b392531ea87a0263', function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});`,
};

export const DELETE_WEBHOOK_RESPONSE_EXAMPLE = {
  bash: `204 No Content`,
};

export const CONVERSATION_CREATED_EVENT_EXAMPLE = {
  json: `{
  "type": "conversation.created",
  "contact": {
    "id": "9354647c5b144a2b4c99f2n42497249",
    "href": "https://rest.messagebird.com/1/contacts/9354647c5b144a2b4c99f2n42497249",
    "msisdn": 316123456789,
    "firstName": "Jen",
    "lastName": "Smith",
    "customDetails": {
      "custom1": null,
      "custom2": null,
      "custom3": null,
      "custom4": null
    },
    "createdDatetime": "2018-06-03T20:06:03Z",
    "updatedDatetime": null
  },
  "conversation": {
    "id": "2f719ebc5b144a18b75f44n12188288",
    "contactId": "9354647c5b144a2b4c99f2n42497249",
    "status": "active",
    "createdDatetime": "2018-03-28T13:28:00Z",
    "updatedDatetime": null,
    "lastReceivedDatetime": null
  },
  "workspaceId": 3917675
}`,
};
export const CONVERSATION_UPDATED_EVENT = {
  json: `{
  "type": "conversation.updated",
  "contact": {
    "id": "9354647c5b144a2b4c99f2n42497249",
    "href": "https://rest.messagebird.com/1/contacts/9354647c5b144a2b4c99f2n42497249",
    "msisdn": 316123456789,
    "firstName": "Jen",
    "lastName": "Smith",
    "customDetails": {
      "custom1": null,
      "custom2": null,
      "custom3": null,
      "custom4": null
    },
    "createdDatetime": "2018-06-03T20:06:03Z",
    "updatedDatetime": null
  },
  "conversation": {
    "id": "2f719ebc5b144a18b75f44n12188288",
    "contactId": "9354647c5b144a2b4c99f2n42497249",
    "status": "archived",
    "createdDatetime": "2018-03-28T13:28:00Z",
    "updatedDatetime": "2018-03-28T13:28:00Z",
    "lastReceivedDatetime": "2018-03-28T13:28:00Z",
    "lastUsedChannelId": "95e223e381364b00b1b21e52bbc6285e",
    "lastUsedPlatformId": "sms"
  },
  "workspaceId": 3917675
}`,
};

export const CONVERSATION_DELETED_EVENT = {
  json: `{
  "type": "conversation.deleted",
  "contact": {
    "id": "9354647c5b144a2b4c99f2n42497249",
    "href": "https://rest.messagebird.com/1/contacts/9354647c5b144a2b4c99f2n42497249",
    "msisdn": 316123456789,
    "firstName": "Jen",
    "lastName": "Smith",
    "customDetails": {
      "custom1": null,
      "custom2": null,
      "custom3": null,
      "custom4": null
    },
    "createdDatetime": "2018-06-03T20:06:03Z",
    "updatedDatetime": null
  },
  "conversation": {
    "id": "2f719ebc5b144a18b75f44n12188288",
    "contactId": "9354647c5b144a2b4c99f2n42497249",
    "status": "deleted",
    "createdDatetime": "2018-03-28T13:28:00Z",
    "updatedDatetime": "2018-03-28T13:28:00Z",
    "lastReceivedDatetime": "2018-03-28T13:28:00Z",
    "lastUsedChannelId": "95e223e381364b00b1b21e52bbc6285e",
    "lastUsedPlatformId": "sms"
  },
  "workspaceId": 3917675
}`,
};

export const MESSAGE_CREATED_EVENT = {
  json: `{
  "type": "message.created",
  "contact": {
    "id": "9354647c5b144a2b4c99f2n42497249",
    "href": "https://rest.messagebird.com/1/contacts/9354647c5b144a2b4c99f2n42497249",
    "msisdn": 316123456789,
    "firstName": "Jen",
    "lastName": "Smith",
    "customDetails": {
      "custom1": null,
      "custom2": null,
      "custom3": null,
      "custom4": null
    },
    "createdDatetime": "2018-06-03T20:06:03Z",
    "updatedDatetime": null
  },
  "conversation": {
    "id": "2f719ebc5b144a18b75f44n12188288",
    "contactId": "9354647c5b144a2b4c99f2n42497249",
    "status": "active",
    "createdDatetime": "2018-03-28T13:28:00Z",
    "updatedDatetime": "2018-03-28T13:28:00Z",
    "lastReceivedDatetime": "2018-03-28T13:28:00Z",
    "lastUsedChannelId": "2f719ebc5b144a18b75f44n12188288",
    "lastUsedPlatformId": "sms"
  },
  "message": {
    "id": "8909570c5b71a40bb957f1n63383684",
    "conversationId": "2f719ebc5b144a18b75f44n12188288",
    "channelId": "2f719ebc5b144a18b75f44n12188288",
    "status": "delivered",
    "type": "text",
    "direction": "sent",
    "content": {
      "text": "hello"
    },
    "createdDatetime": "2018-08-13T15:30:19Z",
    "updatedDatetime": "2018-08-13T15:30:20Z"
  },
  "workspaceId": 3917675
}`,
};
export const MESSAGE_UPDATED_EVENT = {
  json: `{
  "type": "message.updated",
  "contact": {
    "id": "9354647c5b144a2b4c99f2n42497249",
    "href": "https://rest.messagebird.com/1/contacts/9354647c5b144a2b4c99f2n42497249",
    "msisdn": 316123456789,
    "firstName": "Jen",
    "lastName": "Smith",
    "customDetails": {
      "custom1": null,
      "custom2": null,
      "custom3": null,
      "custom4": null
    },
    "createdDatetime": "2018-06-03T20:06:03Z",
    "updatedDatetime": null
  },
  "conversation": {
    "id": "2f719ebc5b144a18b75f44n12188288",
    "contactId": "9354647c5b144a2b4c99f2n42497249",
    "status": "active",
    "createdDatetime": "2018-03-28T13:28:00Z",
    "updatedDatetime": "2018-03-28T13:28:00Z",
    "lastReceivedDatetime": "2018-03-28T13:28:00Z",
    "lastUsedChannelId": "95e223e381364b00b1b21e52bbc6285e",
    "lastUsedPlatformId": "sms"
  },
  "message": {
    "id": "8909570c5b71a40bb957f1n63383684",
    "conversationId": "2f719ebc5b144a18b75f44n12188288",
    "channelId": "2f719ebc5b144a18b75f44n12188288",
    "status": "failed",
    "type": "text",
    "direction": "sent",
    "content": {
      "text": "hello"
    },
    "createdDatetime": "2018-08-13T15:30:19Z",
    "updatedDatetime": "2018-08-13T15:31:20Z"
    },
    "error": {
    "code": 470,
    "description": "Failed to send message because you are outside the support window for freeform messages to this user. Please use a valid message template."
  },
  "workspaceId": 3917675
}
`,
};

export const WHATSAPP_MESSAGE = {
  json: `Hi {{1}}, your order has been shipped and should arrive {{2}}`,
};

export const WHATSAPP_SEND_REQUEST = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/send" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "to": "+31612345678",
    "type": "hsm",
    "from": "aa4c8e7cee664341a22ef9bfd9f52477",
    "content":{
      "hsm": {
        "namespace": "5ba2d0b7_f2c6_433b_a66e_57b009ceb6ff",
        "templateName": "order_update",
        "language": {
        "policy": "deterministic",
        "code": "en"
        },
        "params": [
          {"default": "Bob"},
          {"default": "tomorrow!"}
        ]
      }
    }
  }'`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

var params = {
  'to': '+31612345678',
  'type': 'hsm',
  'from': 'aa4c8e7cee664341a22ef9bfd9f52477',
  'content': {
    'hsm': {
      'namespace': '5ba2d0b7_f2c6_433b_a66e_57b009ceb6ff',
      'templateName': 'order_update',
      'language': {
        'policy': 'deterministic',
        'code': 'en'
      },
      'params': [
        { 'default': 'Bob' },
        { 'default': 'tomorrow!' }
      ]
    }
  }
}

messagebird.conversations.send(params, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});
`,
};

export const WHATSAPP_SEND_RESPONSE = {
  json: `{
  "message": {
    "id": "2e15efafec384e1c82e9842075e87beb",
    "status": "accepted"
  }
}`,
};

export const WHATSAPP_START_REQUEST = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/conversations/start" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "to": "+31612345678",
    "type": "hsm",
    "channelId": "aa4c8e7cee664341a22ef9bfd9f52477",
    "content":{
    "hsm": {
      "namespace": "5ba2d0b7_f2c6_433b_a66e_57b009ceb6ff",
      "templateName": "order_update",
      "language": {
      "policy": "deterministic",
      "code": "en"
      },
      "params": [
        {"default": "Bob"},
        {"default": "tomorrow!"}
      ]
    }
  }'`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

var params = {
  'to': '+31612345678',
  'type': 'hsm',
  'channelId': 'aa4c8e7cee664341a22ef9bfd9f52477',
  'content': {
    'hsm': {
      'namespace': '5ba2d0b7_f2c6_433b_a66e_57b009ceb6ff',
      'templateName': 'order_update',
      'language': {
        'policy': 'deterministic',
        'code': 'en'
      },
      'params': [
        { 'default': 'Bob' },
        { 'default': 'tomorrow!' }
      ]
    }
  }
}

messagebird.conversations.start(params, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});
`,
};

export const WHATSAPP_START_RESPONSE = {
  json: `{
    "id": "2e15efafec384e1c82e9842075e87beb",
    "contactId": "a621095fa44947a28b441cfdf85cb802",
    "contact": {
      "id": "a621095fa44947a28b441cfdf85cb802",
      "href": "https://rest.messagebird.com/1/contacts/a621095fa44947a28b441cfdf85cb802",
      "msisdn": 316123456789,
      "firstName": "Jen",
      "lastName": "Smith",
      "customDetails": {
        "custom1": null,
        "custom2": null,
        "custom3": null,
        "custom4": null
      },
      "createdDatetime": "2018-06-03T20:06:03Z",
      "updatedDatetime": null
    },
    "channels": [
      {
        "id": "aa4c8e7cee664341a22ef9bfd9f52477",
        "name": "My WhatsApp",
        "platformId": "whatsapp",
        "status": "active",
        "createdDatetime": "2018-08-28T11:56:57Z",
        "updatedDatetime": "2018-08-29T08:16:33Z"
      }
    ],
    "status": "active",
    "createdDatetime": "2018-08-13T09:17:22Z",
    "updatedDatetime": "2018-08-29T07:35:48Z",
    "lastReceivedDatetime": "2018-08-29T07:35:48Z",
    "lastUsedChannelId": "619747f69cf940a98fb443140ce9aed2",
    "lastUsedPlatformId": "whatsapp",
    "messages": {
    "totalCount": 24,
    "href": "https://conversations.messagebird.com/v1/conversations/2e15efafec384e1c82e9842075e87beb/messages",
    "lastMessageId": "9d5d5921f5b34f8db415a2397eb762f9",
    }
  }`,
};

export const MEDIA_WHATSAPP_MESSAGE = {
  json: `
  Header:
  Document content
  
  Body:
  Sorry for the delay. Your flight {{1}} is rescheduled to {{2}}. You can find the attachment document here.
  
  Footer:
  Best Regard, Messagebird
  `,
};

export const MEDIA_WHATSAPP_START_REQUEST = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/conversations/start" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "channelId": "aa4c8e7cee664341a22ef9bfd9f52477",
    "to": "+31612345678",
    "type": "hsm",
    "content":{
    "hsm": {
      "namespace": "20332cd4_f095_b080_d255_35677159aaff",
      "templateName": "test_media_complex",
      "language": {
        "policy": "deterministic",
        "code": "en"
      },
      "components": [
        {
          "type": "header",
          "parameters": [
            {
              "type": "document",
              "document": {
                "url": "https://example.com/flight.pdf"
              }
            }
          ]
        },
        {
          "type": "body",
          "parameters": [
            {
              "type": "text",
              "text": "TK 1073"
            },
            {
              "type": "text",
              "text": "18.04.2020"
            }
          ]
        }
      ]
    }
  }
}'`,
};

export const MEDIA_WHATSAPP_START_RESPONSE = {
  json: `{
  "id": "2ec3d1e8725f41b1933906426738e6a5",
  "conversationId": "2e15efafec384e1c82e9842075e87beb",
  "channelId": "aa4c8e7cee664341a22ef9bfd9f52477",
  "platform": "whatsapp",
  "status": "pending",
  "type": "hsm",
  "direction": "sent",
  "content": {
    "hsm": {
      "namespace": "20332cd4_f095_b080_d255_35677159aaff",
      "templateName": "test_media_complex",
      "language": {
        "policy": "deterministic",
        "code": "en"
      },
      "components": [
        {
          "type": "header",
          "parameters": [
            {
              "type": "document",
              "document": {
                "url": "https://example.com/flight.pdf"
              }
            }
          ]
        },
        {
          "type": "body",
          "parameters": [
            {
              "type": "text",
              "text": "TK 1073"
            },
            {
              "type": "text",
              "text": "18.04.2020"
            }
          ]
        }
      ]
    }
  },
  "createdDatetime": "2018-08-29T13:53:44.642664784Z",
  "updatedDatetime": "2018-08-29T13:53:44.673850825Z"
}`,
};

export const MEDIA_WHATSAPP_SEND_REQUEST = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/send" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "to": "+31612345678",
    "type": "hsm",
    "from": "aa4c8e7cee664341a22ef9bfd9f52477",
    "content": {
      "hsm": {
        "namespace": "20332cd4_f095_b080_d255_35677159aaff",
        "templateName": "test_media_complex",
        "language": {
          "policy": "deterministic",
          "code": "en"
        },
        "components": [
          {
            "type": "header",
            "parameters": [
              {
                "type": "document",
                "document": {
                  "url": "https://example.com/flight.pdf"
                }
              }
            ]
          },
          {
            "type": "body",
            "parameters": [
              {
                "type": "text",
                "text": "TK 1073"
              },
              {
                "type": "text",
                "text": "18.04.2020"
              }
            ]
          }
        ]
      }
    }
  }'`,
  node: `var messagebird = require('messagebird')('YOUR_ACCESS_KEY');

var params = {
  'to': '+31612345678',
  'type': 'hsm',
  'from': 'aa4c8e7cee664341a22ef9bfd9f52477',
  'content': {
    'hsm': {
      'namespace': '20332cd4_f095_b080_d255_35677159aaff',
      'templateName': 'test_media_complex',
      'language': {
        'policy': 'deterministic',
        'code': 'en'
      },
      'components': [
        {
          'type': 'header',
          'parameters': [
            {
              'type': 'document',
              'document': {
                'url': 'https://example.com/flight.pdf'
              }
            }
          ]
        },
        {
          'type': 'body',
          'parameters': [
            {
              'type': 'text',
              'text': 'TK 1073'
            },
            {
              'type': 'text',
              'text': '18.04.2020'
            }
          ]
        }
      ]
    }
  }
}

messagebird.conversations.send(params, function (err, response) {
  if (err) {
  return console.log(err);
  }
  console.log(response);
});
`,
};

export const MEDIA_WHATSAPP_SEND_RESPONSE = {
  json: `{
  "message": {
    "id": "2e15efafec384e1c82e9842075e87beb",
    "status": "accepted"
  }
}`,
};

export const MESSAGING_API_URL = {
  json: 'https://messaging.messagebird.com/v1',
};

export const MAPI_UPLOAD_FILE_ENDPOINT = {
  bash: `POST ${MESSAGING_API_URL.json}/files`,
};

export const UPLOAD_FILE_REQUEST_EXAMPLE = {
  curl: `
curl -X POST ${MESSAGING_API_URL.json}/files \
  -H 'Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM' \
  -H 'Content-Disposition: attachment; filename="testing_image.png"' \
  -H 'Content-Type: image/png' \
  --data-binary @input_image.png
`,
};

export const UPLOAD_FILE_RESPONSE_EXAMPLE = {
  json: `
{
  "id": "ebf6acee-d7ae-4375-b726-e247318d3377",
}
`,
};

export const MAPI_FETCH_FILE_ENDPOINT = {
  bash: `GET ${MESSAGING_API_URL.json}/files/{id}`,
};

export const FETCH_FILE_REQUEST_EXAMPLE = {
  curl: `
curl -X GET ${MESSAGING_API_URL.json}/files/ebf6acee-d7ae-4375-b726-e247318d3377
  -H 'Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM'
  --output uploaded_image.png
`,
};

export const LIST_CONVERSATIONS_BY_CONTACT_ENDPOINT = {
  bash: `GET /v1/conversations/contact/{id}`,
};

export const LIST_CONVERSATIONS_BY_CONTACT_REQUEST_EXAMPLE = {
  curl: `
curl -X GET "https://conversations.messagebird.com/v1/conversations/contact/ebf6aceed7ae4375b726e247318d3377"
  -H 'Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM'`,
};

export const LIST_CONVERSATIONS_BY_CONTACT_RESPONSE_EXAMPLE = {
  json: `
{
  "offset": 0,
  "limit": 20,
  "count": 2,
  "totalCount": 2,
  "items": [
    "0b7c237df609487c9c41437dab502889",
    "9eaceec9cd244e7a9b374df81aad4349"
  ]
}
`,
};

export const LINE_BUTTONS_SEND_REQUEST = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/send" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "to":"U1234567890",
    "from":"aa4c8e7cee664341a22ef9bfd9f52477",
    "type":"buttons",
    "content":{
      "buttons": {
        "text":"How can I help you?",
          "items": [
            {
              "text":"I need fries",
              "action":{
                  "type":"text"
              }
            },
            {
              "text":"Share location",
              "action":{
                  "type":"location"
              }
            },
            {
              "text":"Take a picture",
              "action":{
                  "type":"camera"
              }
            },
            {
              "text":"Open camera roll",
              "action":{
                  "type":"camera_roll"
              }
            },
            {
              "text":"Click me",
              "action":{
                  "type":"uri",
                  "uri":"https://messagebird.com/careers"
              }
            }
          ]
        }
    }
  }'`,
};

export const LINE_STICKER_SEND_REQUEST = {
  curl: `curl -X POST "https://conversations.messagebird.com/v1/send" \\
  -H "Authorization: AccessKey test_gshuPaZoeEG6ovbc8M79w0QyM" \\
  -H "Content-Type: application/json" \\
  -d '{
    "to":"U1234567890",
    "from":"aa4c8e7cee664341a22ef9bfd9f52477",
    "type":"lineSticker",
    "content":{
      "lineSticker":{
        "stickerType":"standard",
        "packageId":"446",
        "stickerId":"1988"
      }
    }
  }'`,
};
